import {
  compositionTypeCodeBaselineMeasureReport, compositionTypeCodeComparativeEvidenceReport,
  compositionTypeCodeComparativeEvidenceSynthesisReport, compositionTypeCodeEvidenceReport,
  compositionTypeCodeEvidenceReportPackage, compositionTypeCodeEvidenceTableReportPackage, compositionTypeCodeGuideline, compositionTypeCodeOutcomeMeasureReport,
  compositionTypeCodeParticipantFlowReport,
  compositionTypeCodeRecommendation, compositionTypeCodeResearchStudyDataDictionary,
  compositionTypeCodeSummaryOfFindings, compositionTypeCodeSummaryOfNetEffect,
  emptyReasonNotStarted, emptyTextNoData, knowledgeArtifactTypeCoding, sectionCodeAcceptability,
  sectionCodeAcknowledgements, sectionCodeAction, sectionCodeAnalyzedGroup, sectionCodeAppendices, sectionCodeAssertion,
  sectionCodeBaselineMeasures, sectionCodeCertaintyOfEvidence, sectionCodeColumnHeaders,
  sectionCodeComparativeResults,
  sectionCodeComparator, sectionCodeComparatorDescription, sectionCodeComparatorGroup, sectionCodeCompetingInterests,
  sectionCodeConsiderations, sectionCodeConsiderationsSummary, sectionCodeCostEffectiveness, sectionCodeCosts, sectionCodeDesirableEffects, sectionCodeDirectionOfRecommendation, sectionCodeDiscussion, sectionCodeEnrolledGroup, sectionCodeEquity, sectionCodeEvidence,
  sectionCodeEvidenceForAnalyzedGroup,
  sectionCodeEvidenceForEnrolledGroup,
  sectionCodeEvidenceForScreenedGroup,
  sectionCodeEvidenceWithComparatorAlone, sectionCodeEvidenceWithInterventionAlone,
  sectionCodeFeasibility, sectionCodeGroupAssignment, sectionCodeImplementationConsiderations,
  sectionCodeIntervention, sectionCodeInterventionDescription, sectionCodeInterventionGroup, sectionCodeIntroduction,
  sectionCodeJudgments, sectionCodeJustification, sectionCodeMethods, sectionCodeMonitoringConsiderations,
  sectionCodeNetEffect, sectionCodeNetEffectContribution, sectionCodeOppositeAction,
  sectionCodeOutcomeDesirability, sectionCodeOutcomeMeasure, sectionCodeOutcomeMeasures,
  sectionCodeParticipantFlow, sectionCodePopulation, sectionCodePopulationDescription, sectionCodePreferences, sectionCodeProblemImportance,
  sectionCodeRatings, sectionCodeRatingSystem,
  sectionCodeRecommendationRating,
  sectionCodeRecommendations, sectionCodeRecommendationSpecification, sectionCodeRecommendationStatement,
  sectionCodeReferences, sectionCodeRelativeImportance, sectionCodeResearchConsiderations,
  sectionCodeResearchStudy, sectionCodeResults, sectionCodeResultWithComparatorAlone,
  sectionCodeResultWithInterventionAlone, sectionCodeResultWithInterventionAloneCalculated,
  sectionCodeResultWithInterventionVsComparator, sectionCodeSampleSize, sectionCodeScreenedGroup, sectionCodeStrengthOfRecommendation,
  sectionCodeSubgroupConsiderations, sectionCodeSummary, sectionCodeSummaryOfFindings,
  sectionCodeUndesirableEffects, sectionCodeVariables,
  usageContextCodeEvidenceCommunication
} from './CodeSystemLookup';

const ProfilesByResourceType = {
  ActivityDefinition: {
    RecommendationAction: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-action',
      description: 'The RecommendationAction Profile is used for a recommendation from a clinical practice guideline.',
      htmlDescription: <span>The <b>RecommendationAction</b> Profile is used for a recommendation from a clinical practice guideline.</span>
    }
  },
  ArtifactAssessment: {
    Adaptation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/adaptation',
      description: 'The Adaptation Profile is used for assessments of a knowledge artifact that are used to create a new knowledge artifact through acceptance, rejection or modification of the assessed artifact.',
      htmlDescription: <span>The <b>Adaptation</b> Profile is used for assessments of a knowledge artifact that are used to create a new knowledge artifact through acceptance, rejection or modification of the assessed artifact.</span>
    },
    CertaintyOfEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/certainty-of-evidence',
      description: 'The CertaintyOfEvidence Profile is used for expression of the certainty (also called quality or confidence in the estimates) of an Evidence artifact.',
      htmlDescription: <span>The <b>CertaintyOfEvidence</b> Profile is used for expression of the certainty (also called quality or confidence in the estimates) of an Evidence artifact.</span>,
      contentStarter: [
        {
          "type": sectionCodeRatingSystem
        },
        {
          "type": sectionCodeCertaintyOfEvidence
        }
      ]
    },
    Classification: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/classification',
      description: 'The Classification Profile is used for classifier tags that may be created independently from Resource creators and may be used for search indexes.',
      htmlDescription: <span>The <b>Classification</b> Profile is used for classifier tags that may be created independently from Resource creators and may be used for search indexes.</span>
    },
    Comment: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comment',
      description: 'The Comment Profile is used for comments about a Resource that may be created independently from Resource creators.',
      htmlDescription: <span>The <b>Comment</b> Profile is used for comments about a Resource that may be created independently from Resource creators.</span>
    },
    Comparison: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparison',
      description: 'The Comparison Profile is used for comparisons of knowledge artifacts.',
      htmlDescription: <span>The <b>Comparison</b> Profile is used for comparisons of knowledge artifacts.</span>
    },
    CompositeRating: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/composite-rating',
      description: 'The CompositeRating Profile is used for a composite rating or classification of a Resource that may be created following ratings or classifications by two or more parties.',
      htmlDescription: <span>The <b>CompositeRating</b> Profile is used for a composite rating or classification of a Resource that may be created following ratings or classifications by two or more parties.</span>
    },
    DateAsRating: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/date-as-rating',
      description: 'The DateAsRating Profile is used for representing a date or dateTime as a classifier value.',
      htmlDescription: <span>The <b>DateAsRating</b> Profile is used for representing a date or dateTime as a classifier value.</span>
    },
    EvidenceAssessment: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-assessment',
      description: 'The EvidenceAssessment Profile is used for expression of any aspect of the certainty or quality of an Evidence artifact.',
      htmlDescription: <span>The <b>EvidenceAssessment</b> Profile is used for expression of any aspect of the certainty or quality of an Evidence artifact.</span>,
      contentStarter: [
        {
          "type": sectionCodeRatingSystem
        },
        {
          "type": sectionCodeCertaintyOfEvidence
        }
      ]
    },
    OutcomeImportance: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-importance',
      description: 'The OutcomeImportance Profile is used for expression of the relative importance of an outcome. The outcome is typically expressed with an EvidenceVariable Resource and may use the OutcomeVariable Profile of EvidenceVariable (or OutcomeDefinition Profile of Group).',
      htmlDescription: <span>The <b>OutcomeImportance</b> Profile is used for expression of the relative importance of an outcome. The outcome is typically expressed with an EvidenceVariable Resource and may use the OutcomeVariable Profile of EvidenceVariable (or OutcomeDefinition Profile of Group).</span>
    },
    Rating: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/rating',
      description: 'The Rating Profile is used for classifier tags that may include quantitative ratings and may be created independently from Resource creators.',
      htmlDescription: <span>The <b>Rating</b> Profile is used for classifier tags that may include quantitative ratings and may be created independently from Resource creators.</span>
    },
    RecommendationJustification: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-justification',
      description: 'The RecommendationJustification Profile is used for expressing the rationale, evidence, and judgments supporting a recommendation, such as from a clinical practice guideline.',
      htmlDescription: <span>The <b>RecommendationJustification</b> Profile is used for expressing the rationale, evidence, and judgments supporting a recommendation, such as from a clinical practice guideline.</span>,
      contentStarter: [
        {
          "type": sectionCodeRatingSystem
        },
        {
          "type": sectionCodeStrengthOfRecommendation
        },
        {
          "type": sectionCodeDirectionOfRecommendation
        },
        {
          "type": sectionCodeRatings
        },
        {
          "type": sectionCodeDiscussion
        },
        {
          "type": sectionCodeEvidence,
          "component": [
            {
              "type": sectionCodeSummaryOfFindings
            },
            {
              "type": sectionCodeDesirableEffects
            },
            {
              "type": sectionCodeUndesirableEffects
            },
            {
              "type": sectionCodeDiscussion
            }
          ]
        },
        {
          "type": sectionCodeNetEffect,
          "component": [
            {
              "type": sectionCodePreferences
            },
            {
              "type": sectionCodeDiscussion
            }
          ]
        },
        {
          "type": sectionCodeJudgments,
          "component": [
            {
              "type": sectionCodeJustification
            },
            {
              "type": sectionCodeProblemImportance
            },
            {
              "type": sectionCodeCosts
            },
            {
              "type": sectionCodeCostEffectiveness
            },
            {
              "type": sectionCodeEquity
            },
            {
              "type": sectionCodeAcceptability
            },
            {
              "type": sectionCodeFeasibility
            }
          ]
        },
        {
          "type": sectionCodeCompetingInterests
        }
      ]
    },
    RecommendationRating: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-rating',
      description: 'The RecommendationRating Profile is used for expressing the classifications of a recommendation, such as from a clinical practice guideline. Common classifications include strength of recommendation, direction of recommendation, and certainty of evidence.',
      htmlDescription: <span>The <b>RecommendationRating</b> Profile is used for expressing the classifications of a recommendation, such as from a clinical practice guideline. Common classifications include strength of recommendation, direction of recommendation, and certainty of evidence.</span>,
      contentStarter: [
        {
          "type": sectionCodeRatingSystem
        },
        {
          "type": sectionCodeStrengthOfRecommendation
        },
        {
          "type": sectionCodeDirectionOfRecommendation
        },
        {
          "type": sectionCodeRatings
        },
        {
          "type": sectionCodeCertaintyOfEvidence
        }
      ]
    },
    RiskOfBias: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/risk-of-bias',
      description: 'The RiskOfBias Profile is used for expression of the assessment of the threats to validity (or risk of bias) of an Evidence artifact or an artifact consisting of Evidence or the plan to create Evidence.',
      htmlDescription: <span>The <b>RiskOfBias</b> Profile is used for expression of the assessment of the threats to validity (or risk of bias) of an Evidence artifact or an artifact consisting of Evidence or the plan to create Evidence.</span>,
      contentStarter: [
        {
          "type": sectionCodeRatingSystem
        },
        {
          "type": sectionCodeCertaintyOfEvidence
        }
      ]
    }
  },
  Citation: {
    BookCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/book-citation',
      description: 'The BookCitation Profile is used for citations of a book.',
      htmlDescription: <span>The <b>BookCitation</b> Profile is used for citations of a book.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "D001877",
                display: "Book"
              }
            ]
          }
        ]
      }
    },
    BookPartCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/book-part-citation',
      description: 'The BookPartCitation Profile is used for citations of a part of a book.',
      htmlDescription: <span>The <b>BookPartCitation</b> Profile is used for citations of a part of a book.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            text: "Book Part"
          }
        ]
      }
    },
    DatabaseCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/database-citation',
      description: 'The DatabaseCitation Profile is used for citations of a database.',
      htmlDescription: <span>The <b>DatabaseCitation</b> Profile is used for citations of a database.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "D019991",
                display: "Database"
              }
            ]
          }
        ]
      }
    },
    DatabaseEntryCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/database-entry-citation',
      description: 'The DatabaseEntryCitation Profile is used for citations of a record within a database.',
      htmlDescription: <span>The <b>DatabaseEntryCitation</b> Profile is used for citations of a record within a database.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            text: "Database Entry"
          }
        ]
      }
    },
    DatasetCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/dataset-citation',
      description: 'The DatasetCitation Profile is used for citations of a dataset.',
      htmlDescription: <span>The <b>DatasetCitation</b> Profile is used for citations of a dataset.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "D064886",
                display: "Dataset"
              }
            ]
          }
        ]
      }
    },
    JournalArticleCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/journal-article-citation',
      description: 'The JournalArticleCitation Profile is used for citations of an article published in a periodical venue classified as a journal.',
      htmlDescription: <span>The <b>JournalArticleCitation</b> Profile is used for citations of an article published in a periodical venue classified as a journal.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "D016428",
                display: "Journal Article"
              }
            ]
          }
        ]
      }
    },
    PreprintCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/preprint-citation',
      description: 'The PreprintCitation Profile is used for citations of an article published in a form prior to peer-reviewed publication in a journal, book, or other permanent record.',
      htmlDescription: <span>The <b>PreprintCitation</b> Profile is used for citations of an article published in a form prior to peer-reviewed publication in a journal, book, or other permanent record.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "D000076942",
                display: "Preprint"
              }
            ]
          }
        ]
      }
    },
    SoftwareCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/software-citation',
      description: 'The SoftwareCitation Profile is used for citations of executable code.',
      htmlDescription: <span>The <b>SoftwareCitation</b> Profile is used for citations of executable code.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "executable-app",
                display: "Executable app"
              }
            ]
          }
        ]
      }
    },
    WebPageCitation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/web-page-citation',
      description: 'The WebPageCitation Profile is used for citations of a web page or website, typically when there is not another type being used to classify the cited artifact.',
      htmlDescription: <span>The <b>WebPageCitation</b> Profile is used for citations of a web page or website, typically when there is not another type being used to classify the cited artifact.</span>,
      citedArtifactClassificationToAdd: {
        type: knowledgeArtifactTypeCoding,
        classifier: [
          {
            coding: [
              {
                system: "http://hl7.org/fhir/citation-artifact-classifier",
                code: "Webpage",
                display: "Webpage"
              }
            ]
          }
        ]
      }
    }
  },
  Composition: {
    BaselineMeasureReport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/baseline-measure-report',
      description: 'The BaselineMeasureReport Profile is used for an evidence report including the findings for any number of baseline measures in a research study.',
      htmlDescription: <span>The <b>BaselineMeasureReport</b> Profile is used for an evidence report including the findings for any number of baseline measures in a research study.</span>,
      typeValue: compositionTypeCodeBaselineMeasureReport,
      sectionStarter: [
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    ComparativeEvidenceReport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-report',
      description: 'The ComparativeEvidenceReport Profile is used for an evidence report including the study group, exposure, comparator, and findings for any number of outcomes comparing the exposure to the comparator in the study group.',
      htmlDescription: <span>The <b>ComparativeEvidenceReport</b> Profile is used for an evidence report including the study group, exposure, comparator, and findings for any number of outcomes comparing the exposure to the comparator in the study group.</span>,
      typeValue: compositionTypeCodeComparativeEvidenceReport,
      sectionStarter: [
        {
          "title": "Introduction Section",
          "code": sectionCodeIntroduction,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Population",
          "code": sectionCodePopulation,
          "text": emptyTextNoData,
          "section": [
            {
              "title": "Screened Group",
              "code": sectionCodeScreenedGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Ernolled Group",
              "code": sectionCodeEnrolledGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Analyzed Group",
              "code": sectionCodeAnalyzedGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Population Definition",
              "code": sectionCodePopulationDescription,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            }
          ]
        },
        {
          "title": "Intervention",
          "code": sectionCodeIntervention,
          "section": [
            {
              "title": "Intervention Description",
              "code": sectionCodeInterventionDescription,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Intervention Group",
              "code": sectionCodeInterventionGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            }
          ]
        },
        {
          "title": "Comparator",
          "code": sectionCodeComparator,
          "section": [
            {
              "title": "Comparator Description",
              "code": sectionCodeComparatorDescription,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Comparator Group",
              "code": sectionCodeComparatorGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Group Assignment (EvidenceVariable)",
              "code": sectionCodeGroupAssignment,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            }
          ]
        },
        {
          "title": "Research Study",
          "code": sectionCodeResearchStudy,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Methods Section",
          "code": sectionCodeMethods,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Baseline Measures",
          "code": sectionCodeBaselineMeasures,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Participant Flow",
          "code": sectionCodeParticipantFlow,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Outcomes",
          "code": sectionCodeOutcomeMeasures,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Summary of Findings",
          "code": sectionCodeSummaryOfFindings,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "References Section",
          "code": sectionCodeReferences,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Competing Interests Section",
          "code": sectionCodeCompetingInterests,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Acknowledgements Section",
          "code": sectionCodeAcknowledgements,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Appendices Section",
          "code": sectionCodeAppendices,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    ComparativeEvidenceSynthesisReport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-synthesis-report',
      description: 'The ComparativeEvidenceSynthesisReport Profile is used for an evidence report including the intended population, intended exposure, intended comparator, and findings for any number of outcomes comparing the exposure to the comparator with observed study group, observed exposure group, and observed comparator group unique for each outcome.',
      htmlDescription: <span>The <b>ComparativeEvidenceSynthesisReport</b> Profile is used for an evidence report including the intended population, intended exposure, intended comparator, and findings for any number of outcomes comparing the exposure to the comparator with observed study group, observed exposure group, and observed comparator group unique for each outcome.</span>,
      typeValue: compositionTypeCodeComparativeEvidenceSynthesisReport,
      sectionStarter: [
        {
          "title": "Introduction Section",
          "code": sectionCodeIntroduction,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Population",
          "code": sectionCodePopulation,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Intervention Description",
          "code": sectionCodeInterventionDescription,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Comparator Description",
          "code": sectionCodeComparatorDescription,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Research Study",
          "code": sectionCodeResearchStudy,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Methods Section",
          "code": sectionCodeMethods,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Outcome Measures",
          "code": sectionCodeVariables,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Results",
          "code": sectionCodeResults,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Summary of Findings",
          "code": sectionCodeSummaryOfFindings,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "References Section",
          "code": sectionCodeReferences,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Competing Interests Section",
          "code": sectionCodeCompetingInterests,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Acknowledgements Section",
          "code": sectionCodeAcknowledgements,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Appendices Section",
          "code": sectionCodeAppendices,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    EvidenceReport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report',
      description: 'The EvidenceReport Profile is used for a base structure (canonical resource management) for a report combining any number of Citation, Evidence, EvidenceVariable, EvidenceReport, and related Resources.',
      htmlDescription: <span>The <b>EvidenceReport</b> Profile is used for a base structure (canonical resource management) for a report combining any number of Citation, Evidence, EvidenceVariable, EvidenceReport, and related Resources.</span>,
      typeValue: compositionTypeCodeEvidenceReport,
      sectionStarter: []
    },
    EvidenceReportPackage: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report-package',
      description: 'The EvidenceReportPackage Profile is used for a base structure (canonical resource management) for a report combining any number of Citation, Evidence, EvidenceVariable, EvidenceReport, and related Resources.',
      htmlDescription: <span>The <b>EvidenceReportPackage</b> Profile is used for a base structure to extend the EvidenceReport Profile with optional sections for Introduction, Discussion, Methods, References, Competing Interests, Acknowledgements, and Appendices.</span>,
      typeValue: compositionTypeCodeEvidenceReportPackage,
      sectionStarter: [
        {
          "title": "Introduction Section",
          "code": sectionCodeIntroduction,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Methods Section",
          "code": sectionCodeMethods,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "References Section",
          "code": sectionCodeReferences,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Competing Interests Section",
          "code": sectionCodeCompetingInterests,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Acknowledgements Section",
          "code": sectionCodeAcknowledgements,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Appendices Section",
          "code": sectionCodeAppendices,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    EvidenceTableReportPackage: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-table-report-package',
      description: 'The EvidenceTableReportPackage Profile is used for a base structure to extend the EvidenceReport Profile with Results sections where each results section instance has a focus on a measured variable and a reproducible structure to represent evidence about that measured variable for different groups.',
      htmlDescription: <span>The <b>EvidenceTableReportPackage</b> Profile is used for a base structure to extend the EvidenceReport Profile with Results sections where each results section instance has a focus on a measured variable and a reproducible structure to represent evidence about that measured variable for different groups.</span>,
      typeValue: compositionTypeCodeEvidenceTableReportPackage,
      sectionStarter: [
        {
          "title": "Results for [replace with variable name]",
          "code": sectionCodeResults,
          "focus": {
            "type": "EvidenceVariable",
            "display": "[Click Edit to replace with variable name or EvidenceVariable title]"
          },
          "text": emptyTextNoData,
          "section": [
            {
              "title": "Evidence for Screened Group",
              "code": sectionCodeEvidenceForScreenedGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Evidence for Enrolled Group",
              "code": sectionCodeEvidenceForEnrolledGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Evidence for Analyzed Group",
              "code": sectionCodeEvidenceForAnalyzedGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Evidence with Intervention Alone",
              "code": sectionCodeEvidenceWithInterventionAlone,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Evidence with Comparator Alone",
              "code": sectionCodeEvidenceWithComparatorAlone,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Comparative Evidence",
              "code": sectionCodeComparativeResults,
              "focus": {
                "type": "EvidenceVariable",
                "display": "[Click Edit to replace with variable name or EvidenceVariable title (GroupAssignment Profile)]"
              },
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Population",
              "code": sectionCodePopulation,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Intervention Group",
              "code": sectionCodeInterventionGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Comparator Group",
              "code": sectionCodeComparatorGroup,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            }
          ]
        }
      ]
    },
    Guideline: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline',
      description: 'The Guideline Profile is used for an EvidenceReport Profile to present a summary of a guideline and its recommendations.',
      htmlDescription: <span>The <b>Guideline</b> Profile is used for an EvidenceReport Profile to present a summary of a guideline and its recommendations.</span>,
      typeValue: compositionTypeCodeGuideline,
      sectionStarter: [
        {
          "title": "Summary Section",
          "code": sectionCodeSummary,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Introduction Section",
          "code": sectionCodeIntroduction,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Methods Section",
          "code": sectionCodeMethods,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Recommendations Section",
          "code": sectionCodeRecommendations,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "References Section",
          "code": sectionCodeReferences,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Competing Interests Section",
          "code": sectionCodeCompetingInterests,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Acknowledgements Section",
          "code": sectionCodeAcknowledgements,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Appendices Section",
          "code": sectionCodeAppendices,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    M11Report: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/m11-report',
      description: 'The M11Report Profile is used for a complete report for the International Council for Harmonisation of Technical Requirements for Pharmaceuticals for Human Use (ICH) Clinical Electronic Structured Harmonised Protocol (CeSHarP) M11 Technical Specification.',
      htmlDescription: <span>The <b>M11Report</b> Profile is used for a complete report for the International Council for Harmonisation of Technical Requirements for Pharmaceuticals for Human Use (ICH) Clinical Electronic Structured Harmonised Protocol (CeSHarP) M11 Technical Specification.</span>,
      typeValue: {
        coding: [{
          system: "http://loinc.org",
          code: "35528-9",
          display: "Clinical trial protocol Clinical trial protocol"
        }],
        text: 'CeSHarP Report'
      },
      sectionStarter: [
        {
          "title": "Protocol Summary",
          "code": {
            "text": "section1-protocol-summary"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Protocol Synopsis",
              "code": {
                "text": "section1.1-protocol-synopsis"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Primary and Secondary Objectives and Estimands",
                  "code": {
                    "text": "section1.1.1-objectives-estimands"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Summarise the primary and secondary objectives and any associated estimands in natural, nontechnical (layperson) language. For trials intended to estimate a treatment effect or test a hypothesis related to a treatment effect, include the primary and secondary objectives and any associated estimands using a nontechnical summary describing the objective and treatment effect of interest (estimand). For other types of trials not intended to estimate a treatment effect or test a hypothesis related to a treatment effect, define trial objectives and describe additional information relevant to the clinical question(s) of interest (e.g., the endpoint(s) associated with each objective). For trials with numerous objectives in which the description of objectives will exceed half a page, consider including the most important objectives and estimands in the synopsis and refer to Section 3 Trial Objectives and Associated Estimands, which covers the objectives and estimands in technical detail. For considerations on estimands, refer to ICH E9(R1).]</div>"
                  }
                },
                {
                  "title": "Overall Design",
                  "code": {
                    "text": "section1.1.2-overall-design"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Key aspects of the trial design include Intervention, Intervention Model, Control Type, Control Description, Intervention Assignment Method, Drug/Device Combination Product Indicator, Population Type, Population Diagnosis or Condition, Population Age (Minimum, Maximum), Site Distribution and Geographic Scope, Master Protocol, and Adaptive Trial Design. Entries should Reference Composition Resource or ResearchStudy Resource.]</div>"
                  }
                },
                {
                  "title": "Number of Arms",
                  "code": {
                    "text": "Number of Arms"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Enter the numeric value for the number of arms in the trial. For trials with a different number of arms in different periods, populate this field based on the total number of arms.]</div>"
                  }
                },
                {
                  "title": "Blinding",
                  "code": {
                    "text": "Blinding"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[For designs in which these details may differ in one or more trial periods, answer according to the portion of the trial in which the highest number of blinded roles occurs. Additional details can be provided in Section 6.7.3 Blinding. State 'Blinded roles: The following roles indictated will not be made aware of the treatment group assignment during the trial:' [blinded roles] 'Not applicable (No blinding)' indicates an open-label trial.]</div>"
                  }
                },
                {
                  "title": "Number of Participants",
                  "code": {
                    "text": "Number of Participants"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[State the expected number of participants to be assigned to trial intervention/enrolled.  Indicate whether the number provided is the target or maximum number of individuals to be randomly assigned to trial intervention/enrolled.]</div>"
                  }
                },
                {
                  "title": "Duration",
                  "code": {
                    "text": "Duration"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[See Template instructions. Select one of the two options for total planned duration of trial intervention and trial participation for each participant.  Note that the total duration of trial participation should include any washout and any follow-up periods in which the participant is not receiving trial intervention.  When duration will vary, provide a short explanation (for example, “event-driven” or “adaptive design”.]</div>"
                  }
                },
                {
                  "title": "Committees",
                  "code": {
                    "text": "Committees"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Indicate whether any committee(s) will be reviewing data while the trial is ongoing, and the type of committee.  Common examples include Data Monitoring Committee, Dose Escalation Committee, or Endpoint Adjudication Committee; describe others, if applicable.   List independent committees in the space indicated.  Other committees may be included at the Sponsor’s discretion in the separate space provided.  Committees listed here should be fully described in Section 11.4 Committees.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Trial Schema",
              "code": {
                "text": "section1.2-trial-schema"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[The purpose of this section is to provide a visual depiction of the trial design, orienting users of the protocol to the key features of the design. The schema depicts the trial arms, the flow of individual participant through the progression of trial period(s)/epochs (such as screening, washout/run-in, intervention, and key milestones [e.g., randomisation, cross-over, end of treatment, end of study, post-treatment follow-up]). For complex trials, additional schemas may be added to describe activities or trial periods in greater detail. Entries should Reference SoaPlanDefinition Profile of PlanDefinition Resource.]</div>"
              }
            },
            {
              "title": "Schedule of Activities",
              "code": {
                "text": "section1.3-schedule-of-activities"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[The schedule of activities must capture the procedures that will be accomplished at each trial visit, and all contact with participants, for example, telephone contacts. This includes any tests that are used for eligibility, participant randomisation or stratification, or decisions on trial intervention discontinuation. Allowable windows should be stated for all visits and procedures. A tabular format is recommended. When applicable for studies with extensive sampling (e.g., serial PK sampling) a separate table may be added. Entries should Reference SoaPlanDefinition Profile of PlanDefinition Resource.]</div>"
              }
            }
          ]
        },
        {
          "title": "Introduction",
          "code": {
            "text": "section2-introduction"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Purpose of Trial",
              "code": {
                "text": "section2.1-trial-purpose"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Explain why the trial is needed, and why the research questions being asked are important. Do not restate the objectives or estimands. Do not restate the IB; rather, cross reference to the IB as applicable to the description.]</div>"
              }
            },
            {
              "title": "Assessment of Risks and Benefits",
              "code": {
                "text": "section2.2-benefits-risks"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include an assessment of known and potential risks and benefits, if any, as a result of participating in the trial from the perspective of an individual participant, including the basis of the risk (e.g., nonclinical trials or prior clinical trials). This section may be structured under one single heading 2.2 Assessment of Risks and Benefits, or if applicable under 3 subheadings as 2.2.1 Risk Summary and Mitigation Strategy, 2.2.2 Benefit Assessment and 2.2.3 Overall Risk-Benefit Assessment]</div>"
              },
              "section": [
                {
                  "title": "Risk Summary and Mitigation Strategy",
                  "code": {
                    "text": "section2.2.1-risk-summary"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[You may enter the entire risk summary here or use the subsections for Trial Intervention, Trial Procedures, and Other as noted below.]</div>"
                  },
                  "section": [
                    {
                      "title": "Trial-specific Intervention Risks and Mitigations",
                      "code": {
                        "text": "section2.2.1.1-trial-intervention-risk-summary"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Trial Intervention – Describe risks related to trial-specific treatments and interventions.  For the protocol, focus only on the relevant key risks for THIS trial.  Provide a brief description of strategies to mitigate identified risks or provide a cross-reference to the relevant protocol section.]</div>"
                      }
                    },
                    {
                      "title": "Trial-specific Procedure Risks and Mitigations",
                      "code": {
                        "text": "section2.2.1.2-trial-procedures-risk-summary"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Trial Procedures – Describe risks associated with the design (e.g., placebo arm) and procedures specific to this trial (e.g., biopsies), and any measures to control or mitigate the risks. Provide a brief description of strategies to mitigate identified risks or provide a cross reference to the relevant protocol section. This is not intended to be an exhaustive list of all possible risks associated with trial procedures but should focus on the unique risks inherent in the design or less common or high-risk procedures. As above, provide a brief description of strategies to mitigate identified risks or provide a cross reference to the relevant protocol section.]</div>"
                      }
                    },
                    {
                      "title": "Trial-specific Other Risks and Mitigations",
                      "code": {
                        "text": "section2.2.1.3-trial-other-risk-summary"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Other – Consider risks associated with other items (for example, comparators, challenge agents, imaging agents, medical devices). This could include discussion of risk mitigation for special populations, if not described elsewhere. Insert a line for each, as needed.]</div>"
                      }
                    }
                  ]
                },
                {
                  "title": "Benefit Summary",
                  "code": {
                    "text": "section2.2.2-benefit-summary"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[The benefit summary should describe any physical, psychological, social, or any other potential benefits to individual participants as a result of participating in the trial, addressing immediate potential benefits and/or long-range potential benefits. Clearly state if no benefits to an individual participant can be anticipated, or if potential benefits are unknown. For early clinical trials such as Phase 1 or trials in healthy participants, benefits for an individual participant (other than those of altruism) are expected to be minimal. Benefits to society in general may also be included but should be described separately from the individual participant perspective.]</div>"
                  }
                },
                {
                  "title": "Overall Risk-Benefit Assessment",
                  "code": {
                    "text": "section2.2.3-overall-risk-benefit-assessment"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Provide a succinct, concluding statement on the perceived balance between risks that have been identified from cumulative safety data, protocol procedures, and anticipated efficacy/benefits within the context of the proposed trial.]</div>"
                  }
                }
              ]
            }
          ]
        },
        {
          "title": "Trial Objectives and Associated Estimands",
          "code": {
            "text": "section3-estimands"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Replace with a summary generated from the referenced M11ResearchStudy.]</div>"
          }
        },
        {
          "title": "Trial Design",
          "code": {
            "text": "section4-trial-design"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Description of Trial Design",
              "code": {
                "text": "section4.1-description-of-trial-design"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the overall trial design and intervention model (e.g., single group, parallel group, cross-over, factorial, sequential), the expected number of participants, and the control method (e.g., placebo, active comparator, low dose, external, standard of care, sham procedure, or none [uncontrolled]). If there are any key aspects of the investigational trial intervention that inform the selection of the intervention model, this should be described. If applicable, indicate other design characteristics (e.g., superiority, noninferiority, dose escalation, or equivalence). If the trial will have an adaptive or novel design (e.g., the trial will be conducted under a master protocol), provide a summary of these design aspects. If applicable, describe within-trial transition rules, e.g., transitions involving cohorts or trial parts. Dose escalation or dose-ranging details should also be described. Describe the trial duration with reference to Section 1.2 Trial Schema. Explain what the overall duration for an individual participant is anticipated to be and why, including the sequence and duration of trial periods (e.g., screening, run-in, randomisation, treatment [fixed dose/titration], follow-up/washout periods). Where applicable, include discussion of sentinel dosing (or lack thereof), dose escalation, and cohort expansion. If dose modification decisions are dependent upon review by a committee, include details in Section 11.4 Committees. State the method of assignment to trial intervention the level and method of blinding that will be used with reference to Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding. Describe any other important aspects of the design, e.g.: • geographic scope of trial (e.g., single-centre, multi-centre, or multi-centre and multi-national) • use of decentralised processes, tools, or features in the trial • planned use of a Data Monitoring Committee, or similar review group and cross reference Section 11.4 Committees, for details • whether an interim analysis is planned; if so, refer to details in Section 10.9 Interim Analyses • any planned extension trial, long-term follow-up/registry, planned future use of samples or data, or post-trial sample analysis or other data-related activities]</div>"
              },
              "section": [
                {
                  "title": "Stakeholder Input into Design",
                  "code": {
                    "text": "section4.1.1-stakeholder-input-into-design"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any stakeholder (for example, patient, healthcare professional and patient advocacy groups) involvement in the design of the trial and any suggestions implemented.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Rationale for Trial Design",
              "code": {
                "text": "section4.2-rationale-for-trial-design"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[<Enter Overall Rationale for Trial Design> if not using below optional subheadings.]</div>"
              },
              "section": [
                {
                  "title": "Rationale for Estimand(s)",
                  "code": {
                    "text": "section4.2.1-rationale-estimands"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[When estimands are associated with the Primary and Secondary Objectives described in Section 3 Trial Objectives and Associated Estimands, provide a rationale for the estimand(s) not described elsewhere in the document. This should include a rationale that the selected endpoint(s) are clinically relevant and provide a reliable and valid measurement of the intended intervention effect. It should also include a rationale for the selected strategies for handling intercurrent events.]</div>"
                  }
                },
                {
                  "title": "Rationale for Intervention Model",
                  "code": {
                    "text": "section4.2.2-rationale-intervention-model"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Provide a rationale for the trial intervention model described in Section 4.1 Description of Trial Design with a cross reference to Section 6.2 Rationale for Investigational Intervention Dose and Regimen. Rationale for choice of comparator, if applicable, should be described separately in Section 4.2.5 Rationale for Control Type. A rationale for the choice of trial population should be described separately in Section 5.1 Description of Trial Population and Rationale.]</div>"
                  }
                },
                {
                  "title": "Rationale for Control Type",
                  "code": {
                    "text": "section4.2.3-rationale-comparator"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, provide a rationale for the type and choice of control selected for the trial (e.g., placebo, active drug, combination, external). Describe any known or potential problems associated with the control group selected in light of the specific disease and intervention(s) being studied. If comparators will differ by region, describe. The rationale for dose/dose regimen is explained in Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen.]</div>"
                  }
                },
                {
                  "title": "Rationale for Duration",
                  "code": {
                    "text": "section4.2.4-rationale-duration"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Provide a rationale that the trial duration is appropriate for a reliable and relevant evaluation of the trial intervention per the trial objective(s).]</div>"
                  }
                },
                {
                  "title": "Rationale for Adaptive or Novel Trial Design",
                  "code": {
                    "text": "section4.2.5-rationale-adaptive"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, provide a rationale for the use of an adaptive or novel design.]</div>"
                  }
                },
                {
                  "title": "Rationale for Interim Analysis",
                  "code": {
                    "text": "section4.2.6-rationale-interim-analysis"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, provide a rationale for any interim analysis planned with respect to its purpose (for example, stopping the trial early for efficacy or futility) and timing.]</div>"
                  }
                },
                {
                  "title": "Rationale for Other Trial Design Aspects",
                  "code": {
                    "text": "section4.2.7-rationale-other-aspects"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Discuss rationale for any additional aspects of the design not addressed above.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Trial Stopping Rules",
              "code": {
                "text": "section4.3-trial-stopping-rules"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any trial-specific stopping rules, including guidance on when the trial should be stopped for safety reasons, when a cohort or dose escalation should be terminated, and/or when a given treatment arm should be terminated. If applicable, describe any rules that may result in a temporary pause of dosing and/or enrollment into the trial and criteria for restarting enrollment. Ensure that the trials stopping rules are aligned with the specifications that are described in Section 10.9 for Interim Analyses.]</div>"
              }
            },
            {
              "title": "Start of Trial and End of Trial",
              "code": {
                "text": "section4.4-start-and-end"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Define key timepoints in the trial, including trial start and end definitions (e.g., a key timepoint definition for start of trial might be when the informed consent is signed by the first participant and a key timepoint definition for end of trial might be when participants are no longer being examined or the last participant’s last trial assessment has occurred). Consider local regulatory requirements for these and other definitions (e.g., the first act of recruitment). If appropriate, provide a cross reference to Section 11.11 Early Site Closure.]</div>"
              }
            },
            {
              "title": "Access to Trial Intervention After End of Trial",
              "code": {
                "text": "section4.5-access-after-trial"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any possibilities for access to trial intervention, if any, beyond completion of the trial. Planned extension trials, if described in Section 4.1 Description of Trial Design, do not need to be repeated in this section.]</div>"
              }
            }
          ]
        },
        {
          "title": "Trial Population",
          "code": {
            "text": "section5-trial-population"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Description of Trial Population and Rationale",
              "code": {
                "text": "section5.1-population-description"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the population selected (e.g., healthy participants, adult participants, paediatric participants, pregnant participants, or breastfeeding participants) and how the enrollment criteria reflect the populations that are likely to use the drug if approved. Specify the population age range (e.g., ≤3 months, ≥18 to ≤80 years old) including the time point at which qualification for age criteria is determined (e.g., at time of screening vs randomisation for paediatric trials). Specify any key diagnostic criteria for the population (e.g., “acute lung injury”, or a specific biomarker profile). If applicable, describe similar conditions or diseases and their differential diagnosis. Provide a rationale for the trial population ensuring that the population selected is well defined and clinically recognisable. Describe how the selected population can meet the trial objectives and how the enrollment criteria reflect the population of interest. If the population targeted by a clinical question is based on a subset of the entire trial population, e.g., defined by a particular characteristic measured at baseline (e.g., a specific biomarker), this subset should be justified in this section. Justify whether the trial intervention is to be evaluated in paediatric participants, in adults unable to consent for themselves, other vulnerable participant populations, or those that may respond to the trial intervention differently (e.g., elderly, hepatic or renally impaired, or immunocompromised participants). Entries should Reference CohortDefinition (or StudyEligibilityCriteria) Profile of Group Resource.]</div>"
              }
            },
            {
              "title": "Inclusion Criteria",
              "code": {
                "text": "section5.2-inclusion-criteria"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Inclusion criteria are characteristics that define the trial population, i.e., those criteria that every potential participant must satisfy to qualify for trial enrollment. Entries should Reference CohortDefinition (or StudyEligibilityCriteria) Profile of Group Resource.]</div>"
              }
            },
            {
              "title": "Exclusion Criteria",
              "code": {
                "text": "section5.3-exclusion-criteria"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Exclusion criteria are characteristics that make an individual ineligible for participation. Entries should Reference CohortDefinition (or StudyEligibilityCriteria) Profile of Group Resource.]</div>"
              }
            },
            {
              "title": "Contraception",
              "code": {
                "text": "section5.4-contraception"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Definitions Related to Childbearing Potential",
                  "code": {
                    "text": "section5.4.1-contraception-definitions"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the definitions of: • participant of childbearing potential, and • participant of nonchildbearing potential]</div>"
                  }
                },
                {
                  "title": "Contraception Requirements",
                  "code": {
                    "text": "section5.4.2-contraception-details"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the: • contraceptive methods required, and • duration of use]</div>"
                  }
                }
              ]
            },
            {
              "title": "Lifestyle Restrictions",
              "code": {
                "text": "section5.5-lifestyle-restrictions"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[In the following subsections, describe any restrictions during the trial pertaining to lifestyle and/or diet, intake of caffeine, alcohol, or tobacco, or physical and other activities. If not applicable, include a statement that no restrictions are required.]</div>"
              },
              "section": [
                {
                  "title": "Meals and Dietary Restrictions",
                  "code": {
                    "text": "section5.5.1-dietary-restrictions"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any restrictions on diet (for example, food and drink restrictions, timing of meals relative to dosing, etc.).]</div>"
                  }
                },
                {
                  "title": "Caffeine, Alcohol, Tobacco, and Other Restrictions",
                  "code": {
                    "text": "section5.5.2-substances-restrictions"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any restrictions on the intake of caffeine, alcohol, tobacco, or other restrictions.]</div>"
                  }
                },
                {
                  "title": "Physical Activity Restrictions",
                  "code": {
                    "text": "section5.5.3-activity-restrictions"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any restrictions on activity (for example, in first-in-human trials, activity may be restricted by ensuring participants remain in bed for 4 to 6 hours after dosing).]</div>"
                  }
                },
                {
                  "title": "Other Activity Restrictions",
                  "code": {
                    "text": "section5.5.4-other-restrictions"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe restrictions on any other activity (for example, blood or tissue donation, driving, heavy machinery use, or sun exposure).]</div>"
                  }
                }
              ]
            },
            {
              "title": "Screen Failure and Rescreening",
              "code": {
                "text": "section5.6-screen-failure"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe screen failure and indicate how screen failure will be handled in the trial, including conditions and criteria upon which rescreening is acceptable. If applicable, indicate the circumstances and time window under which a repeat procedure is allowed for screen failure relating to specific inclusion/exclusion criteria for the trial.]</div>"
              }
            }
          ]
        },
        {
          "title": "Trial Intervention and Concomitant Therapy",
          "code": {
            "text": "section6-trial-intervention"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Trial interventions are all pre-specified investigational and noninvestigational medicinal products, medical devices or other interventions intended for the participants during the trial. The investigational trial intervention is the product used in the trial as part of trial objectives. Description of the investigational trial intervention is provided in Section 6.1 Description of Trial Intervention. Other trial interventions that are not part of trial objectives or do not have an investigational role in this trial are described in Section 6.9 Description of Noninvestigational Trial Interventions. Any regional requirements should be noted in the appropriate subsections. Provide an overview of investigational and noninvestigational trial interventions. Classify the trial intervention as IMP, NIMP/AxMP designations based on trial design and regional requirements. Consider an optional table with 12 columns (Arm Name, Arm Type, Intervention Name, Intervention Type, Pharmaceutical Dose Form, Dosage Strength(s), Dosage Level(s), Route of Administration, Regimen/Treatment Period/Vaccination Regimen, Use, IMP/NIMP, Sourcing).]</div>"
          },
          "section": [
            {
              "title": "Description of Investigational Trial Intervention",
              "code": {
                "text": "section6.1-description-of-trial-intervention"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the investigational trial intervention to be administered in each arm of the trial and for each period of the trial including route and mode of administration, dose, dosage regimen, duration of intervention, use, packaging and labelling. Refer to approved regional labelling, as appropriate. For investigational drug/device combination products, include details on the configuration and use of the device and device manufacturer. A device user manual may be referenced in this section. Entries should Reference ExposureDefinition Profile of Group Resource.]</div>"
              }
            },
            {
              "title": "Rationale for Investigational Trial Intervention Dose and Regimen",
              "code": {
                "text": "section6.2-rationale-for-trial-intervention-regimen"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Provide a rationale for the selection of the dose(s) or dose range, pharmaceutical dose form, route of administration, and dosing regimen of the investigational trial intervention, as applicable. This rationale should include relevant results from nonclinical studies and clinical trials that support selection of the dose and regimen. Discuss impact of differences in trial population characteristics (e.g., age, sex, race) which could lead to differences in pharmacokinetics and pharmacodynamics in this trial as compared to previous trials. If applicable, justify any differences in dose regimen or therapeutic use relative to approved labelling. Describe prior trials and other information that support the dose and/or dose regimen of the investigational trial intervention. Include a rationale for prospective dose adjustments incorporated in the trial, if any. Entries should Reference ExposureDefinition Profile of Group Resource.]</div>"
              }
            },
            {
              "title": "Investigational Trial Intervention Administration",
              "code": {
                "text": "section6.3-dosing-and-administration"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the detailed procedures for administration of each participant’s dose of each investigational trial intervention. This may include the timing of dosing (e.g., time of day, interval), the duration (e.g., the length of time participants will be administered the investigational trial intervention), and the timing of dosing relative to meals. Include any specific instructions on who, when or how to prepare and take the dose(s) and how to handle any delayed or missed doses. Dose escalation or cohort expansion as part of the overall design should be covered in Section 4.1 Description of Trial Design. Entries should Reference ActivityDefinition Resource.]</div>"
              }
            },
            {
              "title": "Investigational Trial Intervention Dose Modification",
              "code": {
                "text": "section6.4-dose-modification"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[For each participant, describe any dose modifications allowed, including conditions for such dose modifications, particularly regarding failure to respond or safety concerns. State any minimum period required before a participant’s dose might be raised to the next higher dose or dose range. Include whether it is permissible to start and stop treatment and how dose reductions (if permitted) are to be managed. Information on stopping investigational trial intervention for participants due to safety/other reasons should be described in Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial. Entries should Reference ActivityDefinition Resource.]</div>"
              }
            },
            {
              "title": "Management of Investigational Trial Intervention Overdose",
              "code": {
                "text": "section6.5-management-of-overdose"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe what is meant by investigational trial intervention overdose. Provide any available information on managing the overdose and ensure it is consistent with the Investigator’s Brochure or product labelling. Cross reference these documents as applicable. Entries should Reference ActivityDefinition Resource or PlanDefinition Resource.]</div>"
              }
            },
            {
              "title": "Preparation, Storage, Handling and Accountability of Investigational Trial Intervention",
              "code": {
                "text": "section6.6-preparation-storage-handling"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Preparation of Investigational Trial Intervention",
                  "code": {
                    "text": "section6.6.1-preparation"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any preparation of the investigational trial intervention, and when necessary, who should prepare it. When applicable, describe the maximum hold time once thawed/mixed before administration. Include thawing, diluting, mixing, and reconstitution/preparation instructions. For drug/device combination products, include any relevant assembly or use instructions and reference the package insert that is provided separately. If the instructions are lengthy or complicated, it is acceptable to reference the package insert (if applicable) or include instructions in separate documents provided to the site (e.g., a pharmacy manual and reference the separate documents.]</div>"
                  }
                },
                {
                  "title": "Storage and Handling of Investigational Trial Intervention",
                  "code": {
                    "text": "section6.6.2-storage-handling"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe storage and handling requirements (e.g., protection from light, temperature, humidity) for the investigational trial intervention(s). For trials in which multi-dose vials are utilised, provide additional information regarding stability and expiration time after initial use (e.g., if the seal is broken). Explain how the investigational trial intervention will be provided to the Investigator. If applicable, include details about kits, packaging, or other material of the investigational trial intervention for blinding purposes. If the instructions are lengthy or complicated, it is acceptable to reference the package insert (if applicable) or include instructions in separate documents provided to the site (e.g., a pharmacy manual) and reference the separate documents.]</div>"
                  }
                },
                {
                  "title": "Accountability of Investigational Trial Intervention",
                  "code": {
                    "text": "section6.6.3-accountability"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the accountability method, including: • how the investigational trial intervention will be distributed • who will distribute the investigational trial intervention • participation of a drug storage repository or pharmacy, if applicable • plans for disposal or return of unused product • if applicable, plans for reconciliation of investigational trial intervention]</div>"
                  }
                }
              ]
            },
            {
              "title": "Investigational Trial Intervention Assignment, Randomisation and Blinding",
              "code": {
                "text": "section6.7-assignment-randomisation-blinding"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Participant Assignment to Investigational Trial Intervention",
                  "code": {
                    "text": "section6.7.1-assignment"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[State that at enrollment, participant identification codes should be assigned. Describe the method of assigning participants to investigational trial intervention without being so specific that blinding or randomisation might be compromised. If assignment to investigational trial intervention is by randomisation, describe when randomisation occurs relative to screening. If adaptive randomisation or other methods of covariate balancing/minimisation are employed, include a cross reference to the methods of analysis in Section 10 Statistical Considerations. As applicable, details regarding the implementation of procedures to minimise bias should be described.]</div>"
                  }
                },
                {
                  "title": "Randomisation",
                  "code": {
                    "text": "section6.7.2-randomisation"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the randomisation procedures (e.g., central randomisation procedures), the method used to generate the randomisation schedule (e.g., computer generated), the source of the randomisation schedule (e.g., sponsor, investigator, or other), and whether IxRS will be used. To maintain the integrity of the blinding, do not include the block size.]</div>"
                  }
                },
                {
                  "title": "Measures to Maintain Blinding",
                  "code": {
                    "text": "section6.7.3-blinding"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe efforts to maintain blinding: • The investigational trial interventions are as indistinguishable as possible • Plans for the maintenance of randomisation codes and appropriate blinding for the trial • Procedures for planned (e.g., interim analysis), and unintentional (e.g., breach of procedure) breaking of randomisation codes. For unplanned but intentional actions (e.g., safety events), refer to Section 6.7.4 Emergency Unblinding at the Site. If the trial allows for some investigators or other designated staff to remain unblinded (e.g., to allow them to adjust investigational trial intervention), the means of maintaining the blinding for other investigators or staff should be explained. Measures to prevent unblinding by laboratory measurements or while performing study assessments, if used, should be described.]</div>"
                  }
                },
                {
                  "title": "Emergency Unblinding at the Site",
                  "code": {
                    "text": "section6.7.4-unblinding"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the criteria for breaking the trial blind or participant code. Describe the circumstances that would require breaking the blind, either for an individual participant or all participants, and specify who will be responsible for this decision. Include the procedure for emergency unblinding as well as documentation of unblinding. Indicate to whom the intentional and unplanned unblinding should be reported.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Investigational Trial Intervention Adherence",
              "code": {
                "text": "section6.8-intervention-adherence"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the measures to monitor and document participants’ adherence with investigational trial intervention (e.g., trial intervention accountability records, diary cards, or investigational trial intervention concentration measurements). List what documents are mandatory to complete (e.g., participant drug log) and what source data/records will be used to document investigational trial intervention adherence.]</div>"
              }
            },
            {
              "title": "Non-Investigational Trial Intervention",
              "code": {
                "text": "section6.9-noninvestigational-interventions"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[As stated in Section 6 Trial Intervention and Concomitant Therapy, noninvestigational interventions are pre-specified products used in the trial but are not part of trial objectives and hence, are not investigational trial interventions.]</div>"
              },
              "section": [
                {
                  "title": "Background Trial Intervention",
                  "code": {
                    "text": "section6.9.1-background-intervention"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any background intervention(s), including administration and any conditions for use.]</div>"
                  }
                },
                {
                  "title": "Rescue Therapy",
                  "code": {
                    "text": "section6.9.2-rescue-therapy"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[List all permitted rescue medications, treatments, and/or procedures, including any relevant instructions on administration and any conditions of use. If administration of rescue therapy leads to the temporary discontinuation of trial intervention or a participant’s withdrawal from the trial, refer to Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial.]</div>"
                  }
                },
                {
                  "title": "Other Noninvestigational Trial Intervention",
                  "code": {
                    "text": "section6.9.3-other-therapy"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe the use of any other noninvestigational trial intervention, e.g., challenge agents or diagnostics.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Concomitant Therapy",
              "code": {
                "text": "section6.10-concomitant-therapy"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the concomitant medications, supplements, complementary and alternative therapies, treatments, and/or procedures which are prohibited or permitted during the trial and include details about when the information will be collected (e.g., during screening, at each visit). When appropriate to separate the content, subheadings may be used.]</div>"
              },
              "section": [
                {
                  "title": "Prohibited Concomitant Therapy",
                  "code": {
                    "text": "section6.10.1-prohibited-concomitant-therapy"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any prohibited concomitant therapy.]</div>"
                  }
                },
                {
                  "title": "Permitted Concomitant Therapy",
                  "code": {
                    "text": "section6.10.2-permitted-concomitant-therapy"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If applicable, describe any permitted concomitant therapy.]</div>"
                  }
                }
              ]
            }
          ]
        },
        {
          "title": "Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial",
          "code": {
            "text": "section7-participant-discontinuation"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Discontinuation of Trial Intervention for Individual Participants",
              "code": {
                "text": "section7.1-discontinuation-of-trial-intervention"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Permanent Discontinuation of Trial Intervention",
                  "code": {
                    "text": "section7.1.1-permanent-discontinuation-of-trial-intervention"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe: • the criteria for discontinuation of a participant from any trial intervention, carefully evaluating which are appropriate for the trial population and therapy being studied • how participants who discontinue trial intervention will be followed after discontinuation. Depending on the chosen intercurrent event handling strategy, it will be important to continue to follow and ascertain outcomes in participants who discontinue treatment through the end of the trial to prevent missing data in important analyses. Refer to Section 1.3 Schedule of Activities for assessments to be performed at the time of and following discontinuation of trial intervention • the process for collecting and recording the detailed reasons for discontinuing trial intervention if not described elsewhere]</div>"
                  }
                },
                {
                  "title": "Temporary Discontinuation of Trial Intervention",
                  "code": {
                    "text": "section7.1.2-temporary-discontinuation-of-trial-intervention"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe: • the criteria for temporary discontinuation or interruption of trial intervention for an individual participant • what to do and which restrictions still apply if the participant has to temporarily discontinue or interrupt trial intervention • whether the participant will continue in the trial • which assessments will be performed for the stated duration of the trial. Details of any rechallenge or restart after a safety-related event should be included in Section 7.1.3 Rechallenge.]</div>"
                  }
                },
                {
                  "title": "Rechallenge",
                  "code": {
                    "text": "section7.1.3-rechallenge"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the criteria for rechallenge/restarting trial intervention, how and when to perform rechallenge, number of rechallenges allowed during the trial, and whether all, or specify which, assessments will be performed for the stated duration of the trial. If rechallenge is not allowed, state this.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Discontinuation or Withdrawal from the Trial",
              "code": {
                "text": "section7.2-participant-withdrawal"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the criteria for participant discontinuation or withdrawal from the trial. Describe the reason for withdrawal and the type of data to be collected for the final assessments with reference to the schedule of activities for the participant’s end of study visit unless provided in another section. In many cases, the only reason for a participant being considered withdrawn from the trial should be a participant’s withdrawal of consent to continue to participate in the trial. All other participants, including those who discontinue treatment, should remain in the trial and continue to be followed to prevent missing data in important analyses. Refer to Section 10 Statistical Considerations for the data that must be collected for the trial estimands.]</div>"
              }
            },
            {
              "title": "Management of Loss to Follow-Up",
              "code": {
                "text": "section7.3-lost-to-follow-up"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe how the trial will define how participants are lost to follow-up. In general, participants should be considered lost to follow-up only if they cannot be reached despite multiple attempts to contact. Also describe approaches that will be used to minimise loss to follow-up, such as multiple, diverse methods to remain in contact with participants (e.g., telephone calls, texts, and emails to the participant) and how contacts will be recorded.]</div>"
              }
            }
          ]
        },
        {
          "title": "Trial Assessments and Procedures",
          "code": {
            "text": "section8-assessments"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Trial Assessments and Procedures Considerations",
              "code": {
                "text": "section8.1-assessments-procedures"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe general considerations applicable across trial assessments and procedures.]</div>"
              }
            },
            {
              "title": "Screening/Baseline Assessments and Procedures",
              "code": {
                "text": "section8.2-screening-baseline-assessments"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any assessments and procedures that are unique to screening/baseline (e.g., collection of data on participant characteristics, assessments/procedures performed for the purpose of determining eligibility or for stratification) in this section. Describe screening and baseline assessments and procedures separately when screening and baseline are different or performed at different visits.]</div>"
              }
            },
            {
              "title": "Efficacy Assessments and Procedures",
              "code": {
                "text": "section8.3-efficacy-assessments"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe efficacy assessments and procedures in this section. Cross reference Section 8.7 Immunogenicity Assessments if immunogenicity assessments are used in efficacy determination.]</div>"
              }
            },
            {
              "title": "Safety Assessments and Procedures",
              "code": {
                "text": "section8.4-safety-assessments"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe safety assessments and procedures utilizing the following subsections as applicable. Add level 3 headings as needed. • Identify any noninvestigator party responsible for evaluation of laboratory or other safety assessments (e.g., Sponsor or external Independent Data Monitoring Committee; cross refer to Section 11.4 Committees for details as applicable). • Include guidelines for the medical management of relevant laboratory or other safety assessment abnormalities.]</div>"
              },
              "section": [
                {
                  "title": "Physical Examination",
                  "code": {
                    "text": "section8.4.1-physical-examination"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection and interpretation of physical examinations.]</div>"
                  }
                },
                {
                  "title": "Vital Signs",
                  "code": {
                    "text": "section8.4.2-vital-signs"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection and interpretation of vital signs.]</div>"
                  }
                },
                {
                  "title": "Electrocardiograms",
                  "code": {
                    "text": "section8.4.3-electrocardiograms"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection, interpretation, and archiving of ECGs.]</div>"
                  }
                },
                {
                  "title": "Clinical Laboratory Assessments",
                  "code": {
                    "text": "section8.4.4-clinical-laboratory-assessments"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any specific instructions for the collection and interpretation of clinical laboratory assessments, including: • type of laboratory (central/local/hybrid) • acceptability of additional tests deemed necessary by the investigator or local regulations • instructions for situations in which central laboratory results are not available in time for trial intervention and/or response evaluation, or in the event of a severe disruption (e.g., a pandemic or natural disaster) • treatment algorithms for results out of normal range • cross reference Section 12.1 Clinical Laboratory Tests for laboratory assessment panels]</div>"
                  }
                },
                {
                  "title": "Pregnancy Testing",
                  "code": {
                    "text": "section8.4.5-pregnancy-testing"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection and interpretation of pregnancy testing.]</div>"
                  }
                },
                {
                  "title": "Suicidal Ideation and Behaviour Risk Monitoring",
                  "code": {
                    "text": "section8.4.6-suicidal-ideation"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If the trial meets any of the criteria requiring suicidal ideation and behaviour risk monitoring by the guidance/guideline in each region, include justification for the need for suicidal ideation and behaviour risk monitoring in the study and add any specific instructions for the collection and interpretation of the assessment. In case this is an AESI in the study, justification should also be provided in Section 9.2.4 Adverse Events of Special Interest.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Pharmacokinetics",
              "code": {
                "text": "section8.5-pharmacokinetics"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection and assay of samples and interpretation of PK assessments. • Describe the biological samples collected, the handling of samples, and the assay method. o Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced. • Describe the retention time for the samples (ensuring alignment with the ICF). • Indicate the types of analyses for each sample. • Define the PK parameters to be calculated and the calculation methods.]</div>"
              }
            },
            {
              "title": "Biomarkers",
              "code": {
                "text": "section8.6-biomarkers"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only). Include any specific instructions for the collection of samples and assessment of biomarkers, including pharmacodynamics. If biomarker or pharmacodynamic testing is not included in the study, state “Not Applicable.” •	Describe the biological samples that will be collected (for example, tissue, serum, plasma, etc.). o	Specific sample collection and processing instructions can be described in an appendix or a separate document and cross-referenced. •	Describe the retention time for the samples (ensuring alignment with the ICF). •	Indicate the types of biomarkers that will be studied for each sample. •	Specify whether each sample is optional or required. Required samples must be based on a protocol objective.]</div>"
              },
              "section": [
                {
                  "title": "Genetics and Pharmacogenomics",
                  "code": {
                    "text": "section8.6.1-genetics-pharmacogenomics"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection and assay of samples for genetic and/or pharmacogenomic analysis. • Describe the biological samples that will be collected (for example, tissue, serum, plasma, etc.), handling of samples, and the assay method. o Specific sample collection and processing instructions can be described in an appendix or a separate document and cross-referenced. • Describe the retention time for the samples (ensuring alignment with the ICF). • Indicate the types of analyses that may be studied for each sample.]</div>"
                  }
                },
                {
                  "title": "Pharmacodynamic Biomarkers",
                  "code": {
                    "text": "section8.6.2-pharmacodynamics"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection of samples and assessment of pharmacodynamic biomarkers. • Describe the biological samples that will be collected (for example, tissue, serum, plasma, etc.). o Specific sample collection and processing instructions can be described in an appendix or a separate document and cross-referenced. • Describe the retention time for the samples (ensuring alignment with the ICF). • Indicate the types of biomarkers that will be studied for each sample. • Specify whether each sample is optional or required. Required samples must be based on a protocol objective.]</div>"
                  }
                },
                {
                  "title": "Other Biomarkers",
                  "code": {
                    "text": "section8.6.3-other"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection of samples and assessment of other biomarkers. • Describe the biological samples that will be collected (for example, tissue, serum, plasma, etc.). o Specific sample collection and processing instructions can be described in an appendix or a separate document and cross-referenced. • Describe the retention time for the samples (ensuring alignment with the ICF). • Indicate the types of biomarkers that will be studied for each sample. • Specify whether each sample is optional or required. Required samples must be based on a protocol objective.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Immunogenicity Assessments",
              "code": {
                "text": "section8.7-immunogenicity-assessments"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Include any specific instructions for the collection of samples and interpretation of immunogenicity. If immunogenicity assessments are included within Efficacy Assessments or Safety Assessments, cross-reference to that section. •	Describe the biological samples that will be collected (e.g., tissue, serum, plasma). o Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced. • Describe the retention time for the samples (ensuring alignment with the ICF). • Indicate the types of biomarkers that will be studied for each sample. • Specify whether each sample is optional or required. Required samples must be based on a protocol objective.]</div>"
              }
            },
            {
              "title": "Medical Resource Utilisation and Health Economics",
              "code": {
                "text": "section8.8-economics"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[This section does not apply to COAs. Include this section only for any value evidence and outcomes assessments not included in either the efficacy or safety sections. Describe the health outcome measures, collection method (e.g., diary, physician interview), and participant burden.]</div>"
              }
            }
          ]
        },
        {
          "title": "Adverse Events, Serious Adverse Events, Product Complaints, Pregnancy and Postpartum Information, and Special Safety Situations",
          "code": {
            "text": "section9-adverse-events"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Definitions",
              "code": {
                "text": "section9.1-definitions"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Definitions of Adverse Events",
                  "code": {
                    "text": "section9.1.1-definitions-adverse-events"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the AE definitions, including: • any relevant regional AE requirements • any events that meet and do not meet the AE definition • any trial-specific AE clarifications • if applicable, any clarifications on the AE and SAE definitions for efficacy trials (e.g., lack of efficacy or failure of pharmacological actions reporting)]</div>"
                  }
                },
                {
                  "title": "Definitions of Serious Adverse Events",
                  "code": {
                    "text": "section9.1.2-definitions-serious-adverse-events"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the SAE definitions, including: • Any relevant regional SAE requirements. •	Any events that meet and do not meet the SAE definition. • Any trial-specific SAE clarifications.]</div>"
                  }
                },
                {
                  "title": "Definitions of Product Complaints",
                  "code": {
                    "text": "section9.1.3-definitions-product-complaints"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the definition of product complaints in the context of the trial. If appropriate, include 9.1.3.1 Definition of Medical Device Product Complaints.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Timing and Procedures for Collection and Reporting",
              "code": {
                "text": "section9.2-collection-methods"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify timing and procedures for collection and reporting of AEs, SAEs, product complaints (including medical device product complaints if applicable) and pregnancy and postpartum information in the sections below. This information may be summarized in a tabular format with 7 columns: Event Type, Situational Scope, Reportable Period Start, Reportable Period End, Timing for Reporting to Sponsor or Designee, Method for Reporting, Back-up Method for Reporting.]</div>"
              },
              "section": [
                {
                  "title": "Timing",
                  "code": {
                    "text": "section9.2.1-timing"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify timing for collection and reporting, including: • start and end dates for collection and reporting • frequency of collection and reporting • cross reference to the Schedule of Assessments as appropriate]</div>"
                  }
                },
                {
                  "title": "Collection Procedures",
                  "code": {
                    "text": "section9.2.2-collection-procedures"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify procedures for collection and recording of AEs, SAEs, product complaints (including medical device product complaints if applicable) and pregnancy and postpartum information in the sections below.]</div>"
                  },
                  "section": [
                    {
                      "title": "Identification",
                      "code": {
                        "text": "section9.2.2.1-identification"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify how information will be identified (e.g., spontaneous reporting, solicited questions).]</div>"
                      }
                    },
                    {
                      "title": "Severity",
                      "code": {
                        "text": "section9.2.2.2-severity"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the intensity rating categories/scale.]</div>"
                      }
                    },
                    {
                      "title": "Causality",
                      "code": {
                        "text": "section9.2.2.3-causality"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the causality categories/scale and the procedures for assessing causality.]</div>"
                      }
                    },
                    {
                      "title": "Recording",
                      "code": {
                        "text": "section9.2.2.4-recording"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify procedures for recording.]</div>"
                      }
                    },
                    {
                      "title": "Follow-up",
                      "code": {
                        "text": "section9.2.2.5-followup"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the procedures for follow-up. Include the assessment tools that will be used to monitor the events and the duration of follow-up after appearance of the events.]</div>"
                      }
                    }
                  ]
                },
                {
                  "title": "Reporting",
                  "code": {
                    "text": "section9.2.3-reporting-events"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the reporting method (e.g., an electronic data collection tool or a paper CRF), backup reporting method if applicable and reporting timeline to the Sponsor]</div>"
                  },
                  "section": [
                    {
                      "title": "Regulatory Reporting Requirements",
                      "code": {
                        "text": "section9.2.3.1-regulatory-requirements"
                      },
                      "text": {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify: • the Investigator’s responsibilities for reporting to the Sponsor (and to Ethics Committees, where required), specifying timing of reporting to allow the Sponsor to meet their responsibilities • the Sponsor’s legal/regulatory responsibilities to report to regulatory authorities, ethics committees, and investigators • serious and unexpected adverse reaction reporting]</div>"
                      }
                    }
                  ]
                },
                {
                  "title": "Adverse Events of Special Interest",
                  "code": {
                    "text": "section9.2.4-special-interest"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify any AESI: • any event (serious or nonserious) of scientific and medical concern relative to the trial intervention, for which ongoing monitoring and rapid communication by the investigator to the sponsor can be appropriate • other events that merit reporting to the Sponsor, trial leadership, IRB, and regulatory agencies. Include the following for each AESI: • the definition • the approach for ascertaining information • if applicable, any approach to confirm or adjudicate the occurrence]</div>"
                  }
                },
                {
                  "title": "Disease-related Events or Outcomes Not Qualifying as AEs or SAEs",
                  "code": {
                    "text": "section9.2.5-disease-related-events"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify any DREs, DROs, or both that will not be reported as AEs or SAEs (e.g., seizures in anticonvulsant trials) or state “Not applicable.”]</div>"
                  }
                }
              ]
            },
            {
              "title": "Pregnancy and Postpartum Information",
              "code": {
                "text": "section9.3-pregnancy-postpartum"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Participants Who Become Pregnant During the Trial",
                  "code": {
                    "text": "section9.3.1-pregnant"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify: • the assessments to be performed • type and duration of monitoring • whether participants who become pregnant during the trial may continue with trial intervention or must be discontinued from trial intervention (refer to Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial as applicable) • any trial modifications that need to be made for participants who become pregnant • what information will be collected about a participant who becomes pregnant during the trial (e.g., recording and reporting to the Sponsor, postpartum follow-up, trial intervention discontinuation or continuation, or trial withdrawal). For postpartum follow-up, include the time period (e.g., initial child development) with the justification. If exposure to trial intervention during breastfeeding is applicable, specify: • the assessments to be performed • type and duration of monitoring • what information will be collected for both the participant and child]</div>"
                  }
                },
                {
                  "title": "Participants Whose Partners Become Pregnant",
                  "code": {
                    "text": "section9.3.2-pregnant-partner"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify: • if the investigator will attempt to collect pregnancy information about a participant’s partner, who becomes pregnant during the specified period in the trial • whether the participant whose partner becomes pregnant should be discontinued from trial intervention (refer to Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial as applicable) • the assessments to be performed, type and duration of monitoring, and the information to be collected]</div>"
                  }
                }
              ]
            },
            {
              "title": "Special Safety Situations",
              "code": {
                "text": "section9.4-special-safety-situations"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify special safety situations associated with the trial intervention(s) that do not qualify as an AE or SAE, but require regulatory reporting. Examples include: • misuse or abuse • off-label use (if applicable) • medication error (prescription or dispensing error) • occupational exposure • use outside of what is foreseen in the protocol • unintended exposure of embryo, foetus, or child via maternal exposure (pregnancy or breastfeeding) or via paternal exposure (semen) • lack of therapeutic efficacy; this is not applicable for studies that measure efficacy as a study endpoint • suspected transmission of an infectious agent; this is only applicable for injected or biologic medicinal products • product complaint, including falsified or counterfeit products • suspected drug-food or drug-drug interaction]</div>"
              }
            }
          ]
        },
        {
          "title": "Statistical Considerations",
          "code": {
            "text": "section10-statistics"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Ensure that the data analysis complies with ICH E9 Guideline and ICH E9(R1) Guideline. In general, all relevant data collected in the trial should be considered in this section. No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "General Considerations",
              "code": {
                "text": "section10.1-general-considerations"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Provide general statements related to statistical considerations, such as whether a separate statistical analysis plan exists, which summary statistics will be provided, and the timing of analyses (e.g., “The analysis will include all participant data at trial completion”).]</div>"
              }
            },
            {
              "title": "Analysis Sets",
              "code": {
                "text": "section10.2-analysis-sets"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe analysis sets to be considered at the trial level, i.e., the set of participants whose data are to be included in the analyses, aligned with estimands. Clearly specify the analysis set to be used for each analysis described in Section 10 Statistical Considerations.]</div>"
              }
            },
            {
              "title": "Analyses of Demographics and Other Baseline Variables",
              "code": {
                "text": "section10.3-analyses-demographics"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the summary statistics that will be used to characterize the distribution of demographic and other relevant variables at baseline. Specify when the variables are measured (e.g., at trial inclusion, prior to randomisation, or at the time of randomisation). Relevant variables include but are not limited to: stratification variables specified in Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding, covariates for the statistical models specified in Section 10.4 Analyses Associated with the Primary Objective(s), other suspected predictive or prognostic variables, and variables used for planned subgroup analyses.]</div>"
              }
            },
            {
              "title": "Analyses Associated with the Primary Objective(s)",
              "code": {
                "text": "section10.4-analysis-primary-objective"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No content here. Create a new section for each estimand.]</div>"
              },
              "section": [{
                "title": "Primary Objective <#>",
                "code": {
                  "text": "section10.4.1-analysis-primary-objective-instance"
                },
                "focus": {
                  "type": "EvidenceVariable",
                  "display": "[Replace with VariableDefinition Profile of EvidenceVariable Resource.]"
                },
                "text": {
                  "status": "empty",
                  "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
                },
                "section": [
                  {
                    "title": "Statistical Analysis Method",
                    "code": {
                      "text": "section10.4.1.1-statistical-method"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the statistical analysis methods that will be used to evaluate the primary objective(s) and associated estimand(s) in Section 3.1 Primary Objective(s) and Associated Estimands. Ensure that the statistical hypothesis/model/analysis (and corresponding assumptions) is aligned with the primary estimand(s). For each objective, when applicable, state the null and alternative hypotheses, including the pre-planned type 1 error rate, or alternative criteria for evaluating whether the objective has been met, and relevant operating characteristics if appropriate. Describe the statistical model used and the factors that will be included (covariates and interactions) and any rules for handling these factors (e.g., pooling of centres). If modelling and simulation methods are to be used, describe the model (inputs and outputs), the underlying assumptions, and the method of model fitting. Entries should Reference EndpointAnalysisPlan Profile of Evidence Resource.]</div>"
                    }
                  },
                  {
                    "title": "Handling of Data in Relation to Primary Estimand(s)",
                    "code": {
                      "text": "section10.4.1.2-data-handling"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[For each intercurrent event of the primary estimand(s) (Section 3.1 Primary Objective(s) and Associated Estimands), explain how data will be handled for the statistical analysis in line with the primary estimand. The handling of intercurrent events in the statistical analysis should be aligned with the specific estimand strategies being used. This section should describe in more detail the rationale and handling of the data rather than repeating information from the preceding sections.]</div>"
                    }
                  },
                  {
                    "title": "Handling of Missing Data in Relation to Primary Estimand(s)",
                    "code": {
                      "text": "section10.4.1.3-missing-data-handling"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe how missing data will be addressed (e.g., imputation method and model), state the underlying assumptions, and provide a rationale for the approach.]</div>"
                    }
                  },
                  {
                    "title": "Sensitivity Analysis",
                    "code": {
                      "text": "section10.4.1.4-sensitivity-analysis"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any sensitivity analyses and how their assumptions changed from the assumptions of the main statistical analysis. Sensitivity analyses are a series of analyses conducted with the intent to explore the robustness of inferences from the main estimator to deviations from its underlying modelling assumptions and limitations in the data. Entries should Reference EndpointAnalysisPlan Profile of Evidence Resource.]</div>"
                    }
                  },
                  {
                    "title": "Supplementary Analysis",
                    "code": {
                      "text": "section10.4.1.5-supplementary-analysis"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any supplementary analysis, if applicable. Supplementary analyses are conducted in addition to the main and sensitivity analysis with the intent to provide additional insights into the understanding of the treatment effect.]</div>"
                    }
                  }
                ]
              }]
            },
            {
              "title": "Analyses Associated with the Secondary Objective(s)",
              "code": {
                "text": "section10.5-analysis-secondary-objective"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No content here. Create a new section for each estimand. Unless there is no secondary objective, in which case indicate 'Not applicable.']</div>"
              },
              "section": [{
                "title": "Secondary Objective <#>",
                "code": {
                  "text": "section10.5.1-analysis-secondary-objective-instance"
                },
                "focus": {
                  "type": "EvidenceVariable",
                  "display": "[Replace with VariableDefinition Profile of EvidenceVariable Resource.]"
                },
                "text": {
                  "status": "empty",
                  "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
                },
                "section": [
                  {
                    "title": "Statistical Analysis Method",
                    "code": {
                      "text": "section10.5.1.1-statistical-method"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Clearly specify any secondary hypotheses that will be tested for confirmatory purposes. Entries should Reference EndpointAnalysisPlan Profile of Evidence Resource.]</div>"
                    }
                  },
                  {
                    "title": "Handling of Data in Relation to Secondary Estimand(s)",
                    "code": {
                      "text": "section10.5.1.2-data-handling"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Enter Handling of Data in Relation to Secondary Estimand(s)]</div>"
                    }
                  },
                  {
                    "title": "Handling of Missing Data in Relation to Secondary Estimand(s)",
                    "code": {
                      "text": "section10.5.1.3-missing-data-handling"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe how missing data will be addressed (e.g., imputation method and model), state the underlying assumptions, and provide a rationale for the approach. Refer to the E9(R1) addendum when the estimand framework is used.]</div>"
                    }
                  },
                  {
                    "title": "Sensitivity Analysis",
                    "code": {
                      "text": "section10.5.1.4-sensitivity-analysis"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe sensitivity analyses. Sensitivity analyses are a series of analyses conducted with the intent to explore the robustness of inferences from the main estimator to deviations from its underlying modelling assumptions and limitations in the data. Entries should Reference EndpointAnalysisPlan Profile of Evidence Resource.]</div>"
                    }
                  },
                  {
                    "title": "Supplementary Analysis",
                    "code": {
                      "text": "section10.5.1.5-supplementary-analysis"
                    },
                    "text": {
                      "status": "empty",
                      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any supplementary analysis if applicable. Supplementary analyses are conducted in addition to the main and sensitivity analysis with the intent to provide additional insights into the understanding of the treatment effect.]</div>"
                    }
                  }
                ]
              }]
            },
            {
              "title": "Analyses Associated with the Exploratory Objective(s)",
              "code": {
                "text": "section10.6-analysis-exploratory-objective"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any exploratory analyses, if applicable. Additional subsections may be created to describe the analyses for each exploratory objective, as needed. If there is no exploratory objective, indicate “Not applicable”.]</div>"
              }
            },
            {
              "title": "Safety Analyses",
              "code": {
                "text": "section10.7-safety-analyses"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If safety is a primary and/or secondary objective, describe the corresponding safety analyses in the appropriate section above (Section 10.4 Analyses Associated with the Primary Objective(s) or Section 10.5 Analyses Associated with the Secondary Objective[s]). In this section, describe statistical methods that will be used to analyse relevant safety outcomes, including any AESI. This should typically include specification of a measure to estimate risk within treatment arms, a measure to compare risks across treatment arms, and a measure of statistical uncertainty around the comparison such as a confidence interval.]</div>"
              }
            },
            {
              "title": "Other Analyses",
              "code": {
                "text": "section10.8-other-analyses"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe other analyses not included in Sections 10.3-10.7, such as subgroup analyses.]</div>"
              }
            },
            {
              "title": "Interim Analyses",
              "code": {
                "text": "section10.9-interim-analyses"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe any interim analyses and criteria for stopping or adapting the trial. Ensure alignment with Section 4.3 Trial Stopping Rules. The description should include, but is not limited to, the following. Under circumstances where interim analysis details could impede the integrity of the trial, some of the information can be added in other documents outside of the protocol. • any planned interim analysis, even if it is only to be performed at the request of an oversight body (for example, DMC) • the purpose of the interim analysis, including whether the interim analysis may be used for stopping and/or for other trial adaptations such as sample size re-estimation, alteration to the proportion of participants allocated to each trial group, or changes to eligibility criteria • the applied statistical method; e.g., group sequential test and spending function (e.g., O’Brien-Fleming), as applicable • the parties responsible for performing and reviewing the results of the analyses (e.g., DMC, independent statistician) • when the analyses will be conducted (timing and/or triggers) • the decision criteria—statistical or other—that will be adopted to judge the interim results as part of a guideline for early stopping or other adaptations • who will see the outcome data while the trial is ongoing • whether these individuals will remain blinded to trial groups • how the integrity of the trial implementation will be protected (e.g., maintaining blinding) when decisions are made after interim analyses (e.g., a decision to continue the trial or implement a specific adaptation)]</div>"
              }
            },
            {
              "title": "Multiplicity Adjustments",
              "code": {
                "text": "section10.10-multiplicity-adjustments"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Multiple testing procedures may be needed to limit the probability of false positive findings in a trial. Reasons for carrying out multiple statistical tests include - but are not restricted to - multiple endpoints, multiple treatment groups, multiple hypotheses, subgroups, multiple timepoints. Describe any approaches to multiplicity control for the trial. This description might go beyond the analysis of primary objectives. Specify the statistical approach to control the overall type I error rate as well as the (adjusted) significance levels to test specific hypotheses, as applicable. Clarify whether the tests/confidence intervals are one- or two-sided. State the circumstances under which a trial will be considered to have met its primary objective(s). For example, in a study with two primary efficacy endpoints, this section should state whether the study would be expected to provide statistical evidence on at least one or on both of the endpoints in order to confirm the efficacy of the treatment. For some statistical approaches it might be helpful to include a graphical depiction, as visualisation will be helpful for understanding, coupled with the clinical translation of the mathematical choices. Details regarding interim analyses should be provided in Section 10.9 Interim Analyses.]</div>"
              }
            },
            {
              "title": "Sample Size Determination",
              "code": {
                "text": "section10.11-sample-size-determination"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[This section should detail the methods used for the determination of the sample size. The sample size calculation should be aligned with the primary estimand and the primary analysis, otherwise a justification is needed. Details of sample size calculation should include all relevant information to enable reproduction of the sample size, e.g.,: • referencing any prior studies on which assumptions were based • significance level (including information on the choice of one- or two-sided level) • power • assumed treatment effect and variability • how dropout rate and intercurrent events have been incorporated into sample size calculation • precision of estimator/length of confidence interval. Any assumptions made should be stated and justified. Further analysis of how deviations from the assumptions will affect the sample size should be included. If complex simulations were used to calculate the sample size, consider including details in a separate simulation report as an appendix to the protocol. If the planned sample size is not derived statistically, then this should be explicitly stated along with a rationale for the intended sample size (e.g., exploratory nature of pilot trials; pragmatic considerations for trials in rare diseases). Entries should Reference EndpointAnalysisPlan Profile of Evidence Resource.]</div>"
              }
            }
          ]
        },
        {
          "title": "Trial Oversight and Other General Considerations",
          "code": {
            "text": "section11-oversight"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Regulatory and Ethical Considerations",
              "code": {
                "text": "section11.1-regulatory-considerations"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Provide a high-level statement on the prevailing ethical, legal, and regulatory guidelines that will be applied throughout the trial. For example, This trial will be conducted in accordance with the protocol and with the following: • Ethical principles that have their origin in the Declaration of Helsinki for medical research involving human subjects • Consensus ethical principles derived from international guidelines including the Declaration of Helsinki and the Council for International Organisations of Medical Sciences (CIOMS) International Ethical Guidelines • ICH Good Clinical Practice (GCP) Guidelines • Applicable laws and regulations]</div>"
              }
            },
            {
              "title": "Trial Oversight",
              "code": {
                "text": "section11.2-trial-oversight"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Concisely summarize the trial oversight listing the investigator and sponsor responsibilities not covered in other sections of the protocol which are essential for the operations of the trial, specifying the ones related to quality assurance.]</div>"
              },
              "section": [
                {
                  "title": "Investigator Responsibilities",
                  "code": {
                    "text": "section11.2.1-investigator-responsibilities"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the investigator duties, including the oversight of duties delegated to a third party that may impact the trial conduct at sites, if applicable and if not addressed elsewhere.]</div>"
                  }
                },
                {
                  "title": "Sponsor Responsibilities",
                  "code": {
                    "text": "section11.2.2-sponsor-responsibilities"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the sponsor duties, including those to be transferred to a third party that may impact the investigators sites, if applicable.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Informed Consent Process",
              "code": {
                "text": "section11.3-informed-consent-process"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify the key elements of the informed consent process, including any special needs and how these are addressed (for example, assent, capacity, legally acceptable representative, adolescents who may reach age of majority during the trial, pregnant participants and pregnant partners of participants).]</div>"
              },
              "section": [
                {
                  "title": "Assent Process",
                  "code": {
                    "text": "section11.3.0-assent-process"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Enter Description of Assent Process.]</div>"
                  }
                },
                {
                  "title": "Emergency Consent Process",
                  "code": {
                    "text": "section11.3.0-emergency-consent-process"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If enrollment in the trial may occur during an emergency in which the participant or their legally acceptable representative is not able or available to give consent, describe the consent process.]</div>"
                  }
                },
                {
                  "title": "Informed Consent for Rescreening",
                  "code": {
                    "text": "section11.3.1-rescreening-consent-process"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If participants can be rescreened as described in Section 5.6, state whether the participant needs to complete a new consent. Screen failure and rescreening should be clearly defined in the protocol, with cross reference to those definitions.]</div>"
                  }
                },
                {
                  "title": "Informed Consent for Remaining Samples in Exploratory Research",
                  "code": {
                    "text": "section11.3.2-remaining-samples"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[If participants will be asked to consent to optional exploratory research using the remainder of mandatory samples, describe the use of remaining samples for optional exploratory research. If any exploratory research is planned and additional written consent regarding the use of remaining samples for exploratory research will be obtained, describe the consent process.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Committees",
              "code": {
                "text": "section11.4-committees"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Briefly describe the administrative structure of committees that will be reviewing data while the trial is ongoing, and the type of committee (e.g., Dose Escalation Committee, Data Monitoring Committee or Data Safety Monitoring Board). Note that specific details may be required depending on local law or regulation. If applicable, Committee Charters may be cross referenced. If no committees are involved, state “Not applicable.”]</div>"
              }
            },
            {
              "title": "Insurance and Indemnity",
              "code": {
                "text": "section11.5-insurance-and-indemnity"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Concisely summarize the arrangements for participants insurance and indemnity if not addressed in a separate agreement, if required by the applicable regulatory requirements.]</div>"
              }
            },
            {
              "title": "Risk-Based Quality Management",
              "code": {
                "text": "section11.6-risk-management"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the identified critical to quality factors, associated risks and risk mitigation strategies in the trial or refer to a separate document where this is described.]</div>"
              }
            },
            {
              "title": "Data Governance",
              "code": {
                "text": "section11.7-data-governance"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the key processes for critical trial integrity, traceability and security including a summary of the monitoring approaches enabling accurate collection, reporting, monitoring, transfer, retention, and access if not addressed in separate agreement(s).]</div>"
              }
            },
            {
              "title": "Data Protection",
              "code": {
                "text": "section11.8-data-protection"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe the measures to protect the privacy and confidentiality of personal information of trial participants in accordance with applicable regulatory requirements on personal data protection and any measures that should be taken in case of a data security breach.]</div>"
              }
            },
            {
              "title": "Source Data",
              "code": {
                "text": "section11.9-source-data"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Establish the importance of source data and expectation for traceability of transcribed information back to source. Delineate expectations for investigators (e.g., maintain source data at the site, ensure availability of current records) and trial monitors (e.g., verify CRF data relative to source, ensure that safety of participants is being protected and that conduct is in accordance with GCP). Identify what constitutes source data and its origin or provide a reference to the location of this information, if contained in a separate document, such as a monitoring guideline or source data acknowledgement). Describe the provision for direct access to source data and documents enabling clinical trial-related monitoring, audits and regulatory inspections, if not included in separate agreement(s).]</div>"
              }
            },
            {
              "title": "Protocol Deviations",
              "code": {
                "text": "section11.10-protocol-deviations"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe plans for detecting, reviewing, and reporting any deviations from the protocol or include reference to a separate document.]</div>"
              }
            },
            {
              "title": "Early Site Closure",
              "code": {
                "text": "section11.11-early-site-closure"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
              },
              "section": [
                {
                  "title": "Decision Rights for Site Closure",
                  "code": {
                    "text": "section11.11-early-site-closure#decisionRights"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[List the sponsor’s rights to close a site early. Likewise, list the investigator’s rights to initiate early site closure.]</div>"
                  }
                },
                {
                  "title": "Crteria for Early Closure",
                  "code": {
                    "text": "section11.11-early-site-closure#criteria"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[List the criteria for early closure of a site by the sponsor or investigator.]</div>"
                  }
                },
                {
                  "title": "Responsibilities Following Early Site Closure",
                  "code": {
                    "text": "section11.11-early-site-closure#responsibilities"
                  },
                  "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[List the responsibilities of the sponsor and investigator following early site closure, such as informing the ethics committee(s), and prompt notification of the participant and their transition to appropriate therapy and/or follow-up.]</div>"
                  }
                }
              ]
            },
            {
              "title": "Data Dissemination",
              "code": {
                "text": "section11.12-data-dissemination"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Describe whether the clinical trial will be registered in public databases, including reporting of results, if applicable.]</div>"
              }
            }
          ]
        },
        {
          "title": "Appendix: Supporting Details",
          "code": {
            "text": "section12-supporting-details"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[No text is intended here (header only).]</div>"
          },
          "section": [
            {
              "title": "Clinical Laboratory Tests",
              "code": {
                "text": "section12.1-clinical-laboratory-tests"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Specify which laboratory parameters should be included in each clinical laboratory assessment panel (for example, for haematology, chemistry, urinalysis). A tabular presentation for such information is common. If applicable, include equations and references for locally calculated laboratory results. If not applicable, retain header and enter “Not Applicable.”]</div>"
              }
            },
            {
              "title": "Country/Region-Specific Differences",
              "code": {
                "text": "section12.2-country-specific-differences"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Although global clinical trial practices are increasingly harmonised, some country/ region-specific differences in requirements do exist (for example, document retention periods, contraception requirements).  Where differences in requirements cannot be reconciled, sponsors should explain how they will document and communicate country/region-specific differences (for example, by country/region-specific amendments or addenda). An alternative to country/region-specific amendments is to list the specific differences by country or countries in this section, including a reference to the relevant section of the protocol where the differing requirement applies. If not applicable, retain header and enter “Not Applicable.”]</div>"
              }
            },
            {
              "title": "Prior Protocol Amendment(s)",
              "code": {
                "text": "section12.3-prior-protocol-amendments"
              },
              "text": {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[See M11 for specific guidance if not able to simply state {Not applicable.  This protocol has not been amended.} or {Not applicable.  This is the first protocol amendment.}.]</div>"
              }
            }
          ]
        },
        {
          "title": "Appendix: Glossary of Terms and Abbreviations",
          "code": {
            "text": "section13-glossary"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Define abbreviations and other terms used in the protocol.  A tabular presentation is common and may serve as the definition at first use. Entries should Reference ValueSet Resource or CodeSystem Resource.]</div>"
          }
        },
        {
          "title": "Appendix: References",
          "code": {
            "text": "section14-references"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[References should be listed in a common format that includes all relevant information to identify the source and date published.  If not published, this should be clearly indicated. Entries should Reference Citation Resource.]</div>"
          }
        },
        {
          "title": "Title Page",
          "code": {
            "text": "section0-title-page"
          },
          "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">[Replace with a summary generated from the referenced M11ResearchStudy.]</div>"
          }
        }
      ]
    },
    OutcomeMeasureReport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-measure-report',
      description: 'The OutcomeMeasureReport Profile is used for an evidence report including the findings for any number of outcome measures in a research study.',
      htmlDescription: <span>The <b>OutcomeMeasureReport</b> Profile is used for an evidence report including the findings for any number of outcome measures in a research study.</span>,
      typeValue: compositionTypeCodeOutcomeMeasureReport,
      sectionStarter: [
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    ParticipantFlowReport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-report',
      description: 'The ParticipantFlowReport Profile is used for an evidence report including the counts (and proportions) for any number of participant flow measures in a research study. For example, the ParticipantFlowReport may include the data for a CONSORT Participant Flow Diagram reported with a randomized controlled trial.',
      htmlDescription: <span>The <b>ParticipantFlowReport</b> Profile is used for an evidence report including the counts (and proportions) for any number of participant flow measures in a research study. For example, the ParticipantFlowReport may include the data for a CONSORT Participant Flow Diagram reported with a randomized controlled trial.</span>,
      typeValue: compositionTypeCodeParticipantFlowReport,
      sectionStarter: [
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    Recommendation: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation',
      description: 'The Recommendation Profile is used for an EvidenceReport Profile to present a summary of a recommendation and its RecommendationJustification.',
      htmlDescription: <span>The <b>Recommendation</b> Profile is used for an EvidenceReport Profile to present a summary of a recommendation and its RecommendationJustification.</span>,
      typeValue: compositionTypeCodeRecommendation,
      sectionStarter: [
        {
          "title": "Summary Section",
          "code": sectionCodeSummary,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Introduction Section",
          "code": sectionCodeIntroduction,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Recommendation Specification",
          "code": sectionCodeRecommendationSpecification,
          "text": emptyTextNoData,
          "section": [
            {
              "title": "Recommendation Statement",
              "code": sectionCodeRecommendationStatement,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Recommendation Ratings",
              "code": sectionCodeRatings,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Population",
              "code": sectionCodePopulation,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Action",
              "code": sectionCodeAction,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Opposite Action",
              "code": sectionCodeOppositeAction,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            }
          ]
        },
        {
          "title": "Justification",
          "code": sectionCodeJustification,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Considerations",
          "code": sectionCodeConsiderations,
          "text": emptyTextNoData,
          "section": [
            {
              "title": "Overall Considerations Summary",
              "code": sectionCodeConsiderationsSummary,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Subgroup Considerations",
              "code": sectionCodeSubgroupConsiderations,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Implementation Considerations",
              "code": sectionCodeImplementationConsiderations,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Monitoring Considerations",
              "code": sectionCodeMonitoringConsiderations,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            },
            {
              "title": "Research Considerations",
              "code": sectionCodeResearchConsiderations,
              "text": emptyTextNoData,
              "emptyReason": emptyReasonNotStarted
            }
          ]
        },
        {
          "title": "Methods Section",
          "code": sectionCodeMethods,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Evidence",
          "code": sectionCodeEvidence,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "References Section",
          "code": sectionCodeReferences,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Competing Interests Section",
          "code": sectionCodeCompetingInterests,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Acknowledgements Section",
          "code": sectionCodeAcknowledgements,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Appendices Section",
          "code": sectionCodeAppendices,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    ResearchStudyDataDictionary: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-data-dictionary',
      description: 'The ResearchStudyDataDictionary Profile is used for a code key for variable names in a dataset containing the observations collected in a research study. Each variable is included in a section.entry instance which references a VariableDefinition Profile of EvidenceVariable.',
      htmlDescription: <span>The <b>ResearchStudyDataDictionary</b> Profile is used for a code key for variable names in a dataset containing the observations collected in a research study. Each variable is included in a section.entry instance which references a VariableDefinition Profile of EvidenceVariable.</span>,
      typeValue: compositionTypeCodeResearchStudyDataDictionary,
      sectionStarter: [
        {
          "title": "Variable Definitions",
          "code": sectionCodeVariables,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    SummaryOfFindings: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/summary-of-findings',
      description: 'The SummaryOfFindings Profile is used for an evidence report combining Evidence and EvidenceVariable Resources, organized around VariableDefinition (Profile of EvidenceVariable), to represent the summary of findings of comparative evidence.',
      htmlDescription: <span>The <b>SummaryOfFindings</b> Profile is used for an evidence report combining Evidence and EvidenceVariable Resources, organized around VariableDefinition (Profile of EvidenceVariable), to represent the summary of findings of comparative evidence.</span>,
      typeValue: compositionTypeCodeSummaryOfFindings,
      sectionStarter: [
        {
          "title": "Column Headers",
          "code": sectionCodeColumnHeaders,
          "section": [
            {
              "title": "Outcome Measure",
              "code": sectionCodeOutcomeMeasure,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Outcome</p></div>"
              }
            },
            {
              "title": "Sample Size",
              "code": sectionCodeSampleSize,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Sample Size</p></div>"
              }
            },
            {
              "title": "Result Without Treatment",
              "code": sectionCodeResultWithComparatorAlone,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result Without Treatment</p></div>"
              }
            },
            {
              "title": "Result With Treatment--Observed",
              "code": sectionCodeResultWithInterventionAlone,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result With Treatment (Observed)</p></div>"
              }
            },
            {
              "title": "Result With Treatment--Derived",
              "code": sectionCodeResultWithInterventionAloneCalculated,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result With Treatment (Calculated)</p></div>"
              }
            },
            {
              "title": "Effect Estimate",
              "code": sectionCodeResultWithInterventionVsComparator,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Effect Estimate</p></div>"
              }
            },
            {
              "title": "Certainty of Evidence",
              "code": sectionCodeCertaintyOfEvidence,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Certainty of Evidence</p></div>"
              }
            },
            {
              "title": "Assertion",
              "code": sectionCodeAssertion,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>What this means</p></div>"
              }
            }
          ]
        },
        {
          "title": "Summary of Findings",
          "code": sectionCodeSummaryOfFindings,
          "text": emptyTextNoData,
          "section": [],
          "emptyReason": emptyReasonNotStarted
        }
      ]
    },
    SummaryOfNetEffect: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/summary-of-net-effect',
      description: 'The SummaryOfNetEffect Profile is used for an evidence report combining ArtifactAssessment and Evidence and EvidenceVariable Resources, organized around OutcomeVariable (Profile of EvidenceVariable), to represent the summary of net effect contributions of comparative evidence, adjusted for the relative importance of outcomes.',
      htmlDescription: <span>The <b>SummaryOfNetEffect</b> Profile is used for an evidence report combining ArtifactAssessment and Evidence and EvidenceVariable Resources, organized around OutcomeVariable (Profile of EvidenceVariable), to represent the summary of net effect contributions of comparative evidence, adjusted for the relative importance of outcomes.</span>,
      typeValue: compositionTypeCodeSummaryOfNetEffect,
      sectionStarter: [
        {
          "title": "Introduction Section",
          "code": sectionCodeIntroduction,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Discussion Section",
          "code": sectionCodeDiscussion,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Methods Section",
          "code": sectionCodeMethods,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "References Section",
          "code": sectionCodeReferences,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Competing Interests Section",
          "code": sectionCodeCompetingInterests,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Acknowledgements Section",
          "code": sectionCodeAcknowledgements,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Appendices Section",
          "code": sectionCodeAppendices,
          "text": emptyTextNoData,
          "emptyReason": emptyReasonNotStarted
        },
        {
          "title": "Column Headers",
          "code": sectionCodeColumnHeaders,
          "section": [
            {
              "title": "Outcome",
              "code": sectionCodeOutcomeMeasure,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Outcome</div>"
              }
            },
            {
              "title": "Desirability",
              "code": sectionCodeOutcomeDesirability,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Desirability</div>"
              }
            },
            {
              "title": "Relative Importance",
              "code": sectionCodeRelativeImportance,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Relative Importance</div>"
              }
            },
            {
              "title": "Result Without Treatment",
              "code": sectionCodeResultWithComparatorAlone,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Result Without Treatment</div>"
              }
            },
            {
              "title": "Result With Treatment--Derived",
              "code": sectionCodeResultWithInterventionAloneCalculated,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Result With Treatment (Calculated)</div>"
              }
            },
            {
              "title": "Effect Estimate",
              "code": sectionCodeResultWithInterventionVsComparator,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Difference with Treatment (Confidence Interval)</div>"
              }
            },
            {
              "title": "Net Effect Contribution",
              "code": sectionCodeNetEffectContribution,
              "text": {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">Health Impact (Confidence Interval)</div>"
              }
            }
          ]
        }
      ]
    }
  },
  DocumentReference: {
    ResearchStudySupport: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-support',
      description: 'The ResearchStudySupport Profile is used to classify the type of document used to support a research study.',
      htmlDescription: 'The <b>ResearchStudySupport</b> Profile is used to classify the type of document used to support a research study.',
    }
  },
  Evidence: {
    BaselineMeasureEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/baseline-measure-evidence',
      description: 'The BaselineMeasureEvidence Profile is used for evidence with a measured variable (with the role of outcome for this Evidence) that is considered an independent variable with respect to the outcome of an exposure or intervention in a study.',
      htmlDescription: <span>The <b>BaselineMeasureEvidence</b> Profile is used for evidence with a measured variable (with the role of outcome for this Evidence) that is considered an independent variable with respect to the outcome of an exposure or intervention in a study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "BaselineMeasureEvidence", display: "BaselineMeasureEvidence"
            }
          ]
        }
      }
    },
    ComparativeBaselineMeasureEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-baseline-measure-evidence',
      description: 'The ComparativeBaselineMeasureEvidence Profile is used for comparative evidence with a measured variable (with the role of outcome for this Evidence) that is considered an independent variable with respect to the outcome of an exposure or intervention in a study.',
      htmlDescription: <span>The <b>ComparativeBaselineMeasureEvidence</b> Profile is used for comparative evidence with a measured variable (with the role of outcome for this Evidence) that is considered an independent variable with respect to the outcome of an exposure or intervention in a study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparativeBaselineMeasureEvidence", display: "ComparativeBaselineMeasureEvidence"
            }
          ]
        }
      }
    },
    ComparativeEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence',
      description: 'The ComparativeEvidence Profile is used for evidence with a measured variable that is considered the outcome of an exposure or intervention, and an exposure variable with two or more categories that are being compared.',
      htmlDescription: <span>The <b>ComparativeEvidence</b> Profile is used for evidence with a measured variable that is considered the outcome of an exposure or intervention, and an exposure variable with two or more categories that are being compared.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparativeEvidence", display: "ComparativeEvidence"
            }
          ]
        }
      }
    },
    ComparativeParticipantFlowEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-participant-flow-evidence',
      description: 'The ComparativeParticipantFlowEvidence Profile is used for comparisons of counts of completion and reasons for non-completion of participation in a research study.',
      htmlDescription: <span>The <b>ComparativeParticipantFlowEvidence</b> Profile is used for comparisons of counts of completion and reasons for non-completion of participation in a research study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparativeParticipantFlowEvidence", display: "ComparativeParticipantFlowEvidence"
            }
          ]
        }
      }
    },
    ComparatorOnlyEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparator-only-evidence',
      description: 'The ComparatorOnlyEvidence Profile is used for evidence with a measured variable that is considered the outcome of an exposure or intervention, and an exposure with a categorical value that is the reference category for the exposure (in a ComparativeEvidence Profile). The ComparatorOnlyEvidence describes the evidence for the comparator group.',
      htmlDescription: <span>The <b>ComparatorOnlyEvidence</b> Profile is used for evidence with a measured variable that is considered the outcome of an exposure or intervention, and an exposure with a categorical value that is the reference category for the exposure (in a ComparativeEvidence Profile). The ComparatorOnlyEvidence describes the evidence for the comparator group.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparatorOnlyEvidence", display: "ComparatorOnlyEvidence"
            }
          ]
        }
      }
    },
    EndpointAnalysisPlan: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/endpoint-analysis-plan',
      description: 'The EndpointAnalysisPlan Profile is used for specification of the statistical model for analysis of a single endpoint.',
      htmlDescription: <span>The <b>EndpointAnalysisPlan</b> Profile is used for specification of the statistical model for analysis of a single endpoint.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "EndpointAnalysisPlan", display: "EndpointAnalysisPlan"
            }
          ]
        }
      }
    },
    EvidenceSynthesisEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-synthesis-evidence',
      description: 'The EvidenceSynthesisEvidence Profile is used for evidence that is combined from two or more studies, explicitly expressing the method by which evidence was synthesized.',
      htmlDescription: <span>The <b>EvidenceSynthesisEvidence</b> Profile is used for evidence that is combined from two or more studies, explicitly expressing the method by which evidence was synthesized.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "EvidenceSynthesisEvidence", display: "EvidenceSynthesisEvidence"
            }
          ]
        }
      }
    },
    InterventionOnlyEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/intervention-only-evidence',
      description: 'The InterventionOnlyEvidence Profile is used for evidence with a measured variable that is considered the outcome of an exposure or intervention, and an exposure with a categorical value that is an intervention of interest (not the reference category for the exposure in a ComparativeEvidence Profile). The InterventionOnlyEvidence describes the evidence for the intervention group.',
      htmlDescription: <span>The <b>InterventionOnlyEvidence</b> Profile is used for evidence with a measured variable that is considered the outcome of an exposure or intervention, and an exposure with a categorical value that is an intervention of interest (not the reference category for the exposure in a ComparativeEvidence Profile). The InterventionOnlyEvidence describes the evidence for the intervention group.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "InterventionOnlyEvidence", display: "InterventionOnlyEvidence"
            }
          ]
        }
      }
    },
    NetEffectContribution: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/net-effect-contribution',
      description: 'The NetEffectContribution Profile is used for evidence in which the effect estimates, expressed as risk differences, is multiplied by a relative importance rating of the outcomes.',
      htmlDescription: <span>The <b>NetEffectContribution</b> Profile is used for evidence in which the effect estimates, expressed as risk differences, is multiplied by a relative importance rating of the outcomes.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "NetEffectContribution", display: "NetEffectContribution"
            }
          ]
        }
      }
    },
    NetEffectEstimate: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/net-effect-estimate',
      description: 'The NetEffectEstimate Profile is used for evidence in which the observed data is comparative evidence (effect estimates expressed as risk differences) and relative importance ratings of outcomes.',
      htmlDescription: <span>The <b>NetEffectEstimate</b> Profile is used for evidence in which the observed data is comparative evidence (effect estimates expressed as risk differences) and relative importance ratings of outcomes.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "NetEffectEstimate", display: "NetEffectEstimate"
            }
          ]
        }
      }
    },
    NonComparativeEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/non-comparative-evidence',
      description: 'The NonComparativeEvidence Profile is used for evidence about a single group with no comparisons between groups.',
      htmlDescription: <span>The <b>NonComparativeEvidence</b> Profile is used for evidence about a single group with no comparisons between groups.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "NonComparativeEvidence", display: "NonComparativeEvidence"
            }
          ]
        }
      }
    },
    ParticipantFlowEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-evidence',
      description: 'The ParticipantFlowEvidence Profile is used for counts of completion and reasons for non-completion of participation in a research study.',
      htmlDescription: <span>The <b>ParticipantFlowEvidence</b> Profile is used for counts of completion and reasons for non-completion of participation in a research study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ParticipantFlowEvidence", display: "ParticipantFlowEvidence"
            }
          ]
        }
      }
    },
    SingleStudyEvidence: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/single-study-evidence',
      description: 'The SingleStudyEvidence Profile is used for evidence from single studies, explicitly expressing that no studies were synthesized.',
      htmlDescription: <span>The <b>SingleStudyEvidence</b> Profile is used for evidence from single studies, explicitly expressing that no studies were synthesized.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "SingleStudyEvidence", display: "SingleStudyEvidence"
            }
          ]
        }
      },
      synthesisTypeValue: [
        {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/synthesis-type",
              "code": "NotApplicable",
              "display": "not applicable"
            }
          ]
        }
      ]
    },
    StatisticModel: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model',
      description: 'The StatisticModel Profile is used to add extensions to Evidence for complex expressions for the statistical model or endpoint analysis plan.',
      htmlDescription: <span>The <b>StatisticModel</b> Profile is used to add extensions to Evidence for complex expressions for the statistical model or endpoint analysis plan.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "StatisticModel", display: "StatisticModel"
            }
          ]
        }
      }
    }
  },
  EvidenceVariable: {
    DichotomousIntendedOutcome: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/dichotomous-intended-outcome',
      description: "The DichotomousIntendedOutcome Profile is used to provide a common variable definition for the 'intended' variable in the role of 'outcome' in Evidence Resources, to allow mapping evidence with different observed variables that relate to the same intended outcome.",
      htmlDescription: <span>The <b>DichotomousIntendedOutcome</b> Profile is used to provide a common variable definition for the 'intended' variable in the role of 'outcome' in Evidence Resources, to allow mapping evidence with different observed variables that relate to the same intended outcome.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "DichotomousIntendedOutcome", display: "DichotomousIntendedOutcome"
            }
          ]
        }
      },
      actualValue: false,
      handlingValue: "boolean"
    },
    GroupAssignment: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/group-assignment',
      description: 'The GroupAssignment Profile is used to classify an EvidenceVariable as an exposure managed as a categorical variable. The variable definitions are found in the category element instead of the definition element.',
      htmlDescription: <span>The <b>GroupAssignment</b> Profile is used to classify an EvidenceVariable as an exposure managed as a categorical variable. The variable definitions are found in the category element instead of the definition element.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "GroupAssignment", display: "GroupAssignment"
            }
          ]
        }
      },
      definitionValue: {
        concept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "defined-in-handling-and-category",
              display: "Defined in handling and category elements"
            }
          ]
        }
      }
    },
    ParticipantFlowEvidenceVariable: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-evidence-variable',
      description: 'The ParticipantFlowEvidenceVariable Profile is used to describe outcome measures for completion and non-completion of participation in a research study.',
      htmlDescription: <span>The <b>ParticipantFlowEvidenceVariable</b> Profile is used to describe outcome measures for completion and non-completion of participation in a research study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ParticipantFlowEvidenceVariable", display: "ParticipantFlowEvidenceVariable"
            }
          ]
        }
      },
      handlingValue: "boolean"
    },
    ParticipantFlowReasonEvidenceVariable: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-reason-evidence-variable',
      description: 'The ParticipantFlowReasonEvidenceVariable Profile is used to describe outcome measures for reasons for non-completion of participation in a research study.',
      htmlDescription: <span>The <b>ParticipantFlowReasonEvidenceVariable</b> Profile is used to describe outcome measures for reasons for non-completion of participation in a research study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ParticipantFlowReasonEvidenceVariable", display: "ParticipantFlowReasonEvidenceVariable"
            }
          ]
        }
      },
      handlingValue: "polychotomous"
    },
    VariableDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/variable-definition',
      description: 'The VariableDefinition Profile uses a CodeableReference Datatype to provide a concept (e.g. coding in a code system) and/or a reference to a Group Resource for structured data to define the variable.',
      htmlDescription: <span>The <b>VariableDefinition</b> Profile uses a CodeableReference Datatype to provide a concept (e.g. coding in a code system) and/or a reference to a Group Resource for structured data to define the variable.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "VariableDefinition", display: "VariableDefinition"
            }
          ]
        }
      }
    }
  },
  Group: {
    CohortDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/cohort-definition',
      description: 'The CohortDefinition Profile is used to provide a definitional representation of a Group. The type element is required. (Alternatively, the ConceptualCohortDefinition Profile uses membership = conceptual and allows avoiding the required use of type.)',
      htmlDescription: <span>The <b>CohortDefinition</b> Profile is used to provide a definitional representation of a Group. The type element is requried. (Alternatively, the ConceptualCohortDefinition Profile uses membership = conceptual and allows avoiding the required use of type.)</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "CohortDefinition", display: "CohortDefinition"
            }
          ]
        }
      },
      membershipValue: "definitional"
    },
    ComparativeEvidenceReportSubject: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-report-subject',
      description: 'The ComparativeEvidenceReportSubject Profile is used to define the subject of an EvidenceReport.',
      htmlDescription: <span>The <b>ComparativeEvidenceReportSubject</b> Profile is used to define the subject of an EvidenceReport.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparativeEvidenceReportSubject", display: "ComparativeEvidenceReportSubject"
            }
          ]
        }
      },
      membershipValue: "conceptual",
      combinationMethodValue: "all-of",
      characteristicStarter: [
        {
          code: { text: "Population" },
          exclude: false
        },
        {
          code: { text: "Intervention or Exposure" },
          exclude: false
        },
        {
          code: { text: "Comparator" },
          exclude: false
        },
        {
          code: { text: "Outcomes" },
          exclude: false
        }
      ]
    },
    ComparatorDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparator-definition',
      description: 'The ComparatorDefinition Profile is used to express the criteria defining a reference group for comparison.',
      htmlDescription: <span>The <b>ComparatorDefinition</b> Profile is used to express the criteria defining a reference group for comparison.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparatorDefinition", display: "ComparatorDefinition"
            }
          ]
        }
      },
      membershipValue: "definitional"
    },
    ComparatorGroup: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/comparator-group',
      description: 'The ComparatorGroup Profile is used to represent a group (definitional or enumerated) used as a comparator in a ComparativeEvidence.',
      htmlDescription: <span>The <b>ComparatorGroup</b> Profile is used to represent a group (definitional or enumerated) used as a comparator in a ComparativeEvidence.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ComparatorGroup", display: "ComparatorGroup"
            }
          ]
        }
      },
      membershipValue: "enumerated"
    },
    ConceptualCohortDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/conceptual-cohort-definition',
      description: 'The ConceptualCohortDefinition Profile is used to provide a conceptual representation of a Group. The membership = conceptual allows avoiding the required use of type.',
      htmlDescription: <span>The <b>ConceptualCohortDefinition</b> Profile is used to provide a conceptual representation of a Group. The membership = conceptual allows avoiding the required use of type.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ConceptualCohortDefinition", display: "ConceptualCohortDefinition"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    ConceptualComparatorDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/conceptual-comparator-definition',
      description: 'The ConceptualComparatorDefinition Profile is used to express the criteria defining a reference group for comparison, where the type of Group is conceptual.',
      htmlDescription: <span>The <b>ConceptualComparatorDefinition</b> Profile is used to express the criteria defining a reference group for comparison, where the type of Group is conceptual.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ConceptualComparatorDefinition", display: "ConceptualComparatorDefinition"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    ConceptualExposureDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/conceptual-exposure-definition',
      description: 'The ConceptualExposureDefinition Profile is used to express the criteria defining an evidence variable (or categorical value for a variable) in the role of exposure, where the type of Group is conceptual.',
      htmlDescription: <span>The <b>ConceptualExposureDefinition</b> Profile is used to express the criteria defining an evidence variable (or categorical value for a variable) in the role of exposure, where the type of Group is conceptual.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ConceptualExposureDefinition", display: "ConceptualExposureDefinition"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    EvidenceReportSubject: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report-subject',
      description: 'The EvidenceReportSubject Profile is used to define the subject of an EvidenceReport.',
      htmlDescription: <span>The <b>EvidenceReportSubject</b> Profile is used to define the subject of an EvidenceReport.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "EvidenceReportSubject", display: "EvidenceReportSubject"
            }
          ]
        }
      },
      membershipValue: "conceptual",
      combinationMethodValue: "all-of"
    },
    ExposureDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/exposure-definition',
      description: 'The ExposureDefinition Profile is used to express the criteria defining an evidence variable (or categorical value for a variable) in the role of exposure.',
      htmlDescription: <span>The <b>ExposureDefinition</b> Profile is used to express the criteria defining an evidence variable (or categorical value for a variable) in the role of exposure.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ExposureDefinition", display: "ExposureDefinition"
            }
          ]
        }
      },
      membershipValue: "definitional"
    },
    ExposureGroup: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/exposure-group',
      description: 'The ExposureGroup Profile is used to represent a group (definitional or enumerated) used in a ComparativeEvidence.',
      htmlDescription: <span>The <b>ExposureGroup</b> Profile is used to represent a group (definitional or enumerated) used in a ComparativeEvidence.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "ExposureGroup", display: "ExposureGroup"
            }
          ]
        }
      },
      membershipValue: "enumerated"
    },
    MetaanalysisEligibilityCriteria: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/metaanalysis-eligibility-criteria',
      description: 'The MetaanalysisEligibilityCriteria Profile is used to describe inclusion and exclusion criteria for a meta-analysis.',
      htmlDescription: <span>The <b>MetaanalysisEligibilityCriteria</b> Profile is used to describe inclusion and exclusion criteria for a meta-analysisused to describe inclusion and exclusion criteria for a meta-analysis.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "MetaanalysisEligibilityCriteria", display: "MetaanalysisEligibilityCriteria"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    MetaanalysisOutcomeDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/metaanalysis-outcome-definition',
      description: 'The MetaanalysisOutcomeDefinition Profile is used to express the criteria defining an evidence variable in the role of outcome where the population (dataset) is a set of Evidence Resources. Characteristics define the characteristics of the Evidence Resource to be eligible to be used for this outcome.',
      htmlDescription: <span>The <b>MetaanalysisOutcomeDefinition</b> Profile is used to express the criteria defining an evidence variable in the role of outcome where the population (dataset) is a set of Evidence Resources. Characteristics define the characteristics of the Evidence Resource to be eligible to be used for this outcome.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "MetaanalysisOutcomeDefinition", display: "MetaanalysisOutcomeDefinition"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    MetaanalysisStudyGroup: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/metaanalysis-study-group',
      description: 'The MetaanalysisStudyGroup Profile is used to represent an enumerated group of participants in a meta-analysis where the participants are Evidence Resources and the Group membership is conceptual.',
      htmlDescription: <span>The <b>MetaanalysisStudyGroup</b> Profile is used to represent an enumerated group of participants in a meta-analysis where the participants are Evidence Resources and the Group membership is conceptual.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "MetaanalysisStudyGroup", display: "MetaanalysisStudyGroup"
            }
          ]
        }
      },
      membershipValue: "conceptual",
      codeValue: { text: "Evidence" },
      characteristicStarter: [
        {
          code: { text: "Member of" },
          exclude: false
        }
      ]
    },
    NetEffectContributions: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/net-effect-contributions',
      description: 'The NetEffectContributions Profile is used to represent an enumerated group of participants in a net effect analysis where the participants are Evidence Resources (NetEffectContribution Profile) and the Group membership is conceptual.',
      htmlDescription: <span>The <b>NetEffectContributions</b> Profile is used to represent an enumerated group of participants in a net effect analysis where the participants are Evidence Resources (NetEffectContribution Profile) and the Group membership is conceptual.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "NetEffectContributions", display: "NetEffectContributions"
            }
          ]
        }
      },
      membershipValue: "conceptual",
      codeValue: { text: "Net Effect Contribution" },
      characteristicStarter: [
        {
          code: { text: "Member of" },
          exclude: false
        }
      ]
    },
    OutcomeDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-definition',
      description: 'The OutcomeDefinition Profile is used to express the criteria defining an evidence variable (or categorical value for a variable) in the role of outcome.',
      htmlDescription: <span>The <b>OutcomeDefinition</b> Profile is used to express the criteria defining an evidence variable (or categorical value for a variable) in the role of outcome.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "OutcomeDefinition", display: "OutcomeDefinition"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    RecommendationEligibilityCriteria: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-eligibility-criteria',
      description: 'The RecommendationEligibilityCriteria Profile is used to express the criteria defining a group for whom a recommendation applies.',
      htmlDescription: <span>The <b>RecommendationEligibilityCriteria</b> Profile is used to express the criteria defining a group for whom a recommendation applies.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "RecommendationEligibilityCriteria", display: "RecommendationEligibilityCriteria"
            }
          ]
        }
      },
      membershipValue: "definitional"
    },
    SearchStrategy: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/search-strategy',
      description: 'The SearchStrategy Profile is used to express the criteria defining a search strategy, such as for a systematic review.',
      htmlDescription: <span>The <b>SearchStrategy</b> Profile is used to express the criteria defining a search strategy, such as for a systematic review.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "SearchStrategy", display: "SearchStrategy"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    },
    StudyEligibilityCriteria: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/study-eligibility-criteria',
      description: 'The StudyEligibilityCriteria Profile is used to describe inclusion and exclusion criteria for a clinical trial or other research study.',
      htmlDescription: <span>The <b>StudyEligibilityCriteria</b> Profile is used to describe inclusion and exclusion criteria for a clinical trial or other research study.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "StudyEligibilityCriteria", display: "StudyEligibilityCriteria"
            }
          ]
        }
      },
      membershipValue: "definitional"
    },
    StudyGroup: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/study-group',
      description: 'The StudyGroup Profile is used to represent an enumerated group of participants in a research study.',
      htmlDescription: <span>The <b>StudyGroup</b> Profile is used to represent an enumerated group of participants in a research study.</span>,
      membershipValue: 'enumerated',
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "StudyGroup", display: "StudyGroup"
            }
          ]
        }
      }
    },
    SystematicReviewEligibilityCriteria: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/systematic-review-eligibility-criteria',
      description: 'The SystematicReviewEligibilityCriteria Profile is used to describe inclusion and exclusion criteria for a systematic review.',
      htmlDescription: <span>The <b>SystematicReviewEligibilityCriteria</b> Profile is used to describe inclusion and exclusion criteria for a systematic review.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "SystematicReviewEligibilityCriteria", display: "SystematicReviewEligibilityCriteria"
            }
          ]
        }
      },
      membershipValue: "conceptual"
    }
  },
  Library: {
    SearchResults: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/search-results',
      description: 'The SearchResults Profile is used to represent search results, such as for a systematic review.',
      htmlDescription: <span>The <b>SearchResults</b> Profile is used to represent search results, such as for a systematic review.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "SearchResults", display: "SearchResults"
            }
          ]
        }
      },
      typeValue: {
        coding: [{
          system: "http://terminology.hl7.org/CodeSystem/library-type",
          code: "asset-collection",
          display: "Asset Collection"
        }]
      }
    },
    SystematicReviewExcludedStudies: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/systematic-review-excluded-studies',
      description: 'The SystematicReviewExcludedStudies Profile is used to represent the subset of search results of a systematic review which did not meet the inclusion criteria.',
      htmlDescription: <span>The <b>SystematicReviewExcludedStudies</b> Profile is used to represent the subset of search results of a systematic review which did not meet the inclusion criteria.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "SystematicReviewExcludedStudies", display: "SystematicReviewExcludedStudies"
            }
          ]
        }
      },
      typeValue: {
        coding: [{
          system: "http://terminology.hl7.org/CodeSystem/library-type",
          code: "asset-collection",
          display: "Asset Collection"
        }]
      }
    },
    SystematicReviewIncludedStudies: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/systematic-review-included-studies',
      description: 'The SystematicReviewIncludedStudies Profile is used to represent the subset of search results of a systematic review which meet the inclusion criteria.',
      htmlDescription: <span>The <b>SystematicReviewIncludedStudies</b> Profile is used to represent the subset of search results of a systematic review which meet the inclusion criteria.</span>,
      useContextToAdd: {
        code: usageContextCodeEvidenceCommunication,
        valueCodeableConcept: {
          coding: [
            {
              system: "https://fevir.net/resources/CodeSystem/179423",
              code: "SystematicReviewIncludedStudies", display: "SystematicReviewIncludedStudies"
            }
          ]
        }
      },
      typeValue: {
        coding: [{
          system: "http://terminology.hl7.org/CodeSystem/library-type",
          code: "asset-collection",
          display: "Asset Collection"
        }]
      }
    }
  },
  List: {
    BaselineVariablesList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/baseline-variables-list',
      description: 'The BaselineVariablesList Profile is used to provide a list of EvidenceVariable Resources which represent baseline measures.',
      htmlDescription: <span>The <b>BaselineVariablesList</b> Profile is used to provide a list of EvidenceVariable Resources which represent baseline measures.</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'BaselineVariablesList',
          display: 'BaselineVariablesList'
        }],
        text: 'Baseline Variables List'
      }
    },
    EvidenceList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-list',
      description: 'The EvidenceList Profile is used to provide a list of Evidence Resources. The EvidenceList Profile is used to represent a Group of Evidence for the population for an EvidenceSynthesisEvidence using a summary data meta-analysis approach and is referenced from a MetaanalysisStudyGroup.',
      htmlDescription: <span>The <b>EvidenceList</b> Profile is used to provide a list of Evidence Resources. The EvidenceList Profile is used to represent a Group of Evidence for the population for an EvidenceSynthesisEvidence using a summary data meta-analysis approach and is referenced from a MetaanalysisStudyGroup.</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'EvidenceList',
          display: 'EvidenceList'
        }],
        text: 'Evidence List'
      }
    },
    NetEffectContributionList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/net-effect-contribution-list',
      description: 'The NetEffectContributionList Profile used to provide a list of Evidence Resources (NetEffectContribution Profile). The NetEffectContributionList Profile is used to represent a Group of Evidence for the population for a NetEffectEstimate (Profile of Evidence) using a net effect analysis approach and is referenced from a NetEffectContributions (Profile of Group).',
      htmlDescription: <span>The <b>NetEffectContributionList</b> Profile is used to provide a list of Evidence Resources (NetEffectContribution Profile). The NetEffectContributionList Profile is used to represent a Group of Evidence for the population for a NetEffectEstimate (Profile of Evidence) using a net effect analysis approach and is referenced from a NetEffectContributions (Profile of Group).</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'NetEffectContributionList',
          display: 'NetEffectContributionList'
        }],
        text: 'Net Effect Contributions List'
      }
    },
    OutcomeList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-list',
      description: 'The OutcomeList Profile is used to provide a list of outcomes. The OutcomeList Profile is referenced in the EvidenceReportSubject Profile as a way to define the set of outcomes that an EvidenceReport is about.',
      htmlDescription: <span>The <b>OutcomeList</b> Profile is used to provide a list of outcomes. The OutcomeList Profile is referenced in the EvidenceReportSubject Profile as a way to define the set of outcomes that an EvidenceReport is about.</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'OutcomeList',
          display: 'OutcomeList'
        }],
        text: 'Outcome List'
      }
    },
    OutcomeVariablesList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-variables-list',
      description: 'The OutcomeVariablesList Profile is used to provide a list of EvidenceVariable Resources which represent outcome measures.',
      htmlDescription: <span>The <b>OutcomeVariablesList</b> Profile is used to provide a list of EvidenceVariable Resources which represent outcome measures.</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'OutcomeVariablesList',
          display: 'OutcomeVariablesList'
        }],
        text: 'Outcome Variables List'
      }
    },
    ParticipantFlowVariablesList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-variables-list',
      description: 'The ParticipantFlowVariablesList Profile is used to provide a list of EvidenceVariable Resources which represent participant flow measures.',
      htmlDescription: <span>The <b>ParticipantFlowVariablesList</b> Profile is used to provide a list of EvidenceVariable Resources which represent participant flow measures.</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'ParticipantFlowVariablesList',
          display: 'ParticipantFlowVariablesList'
        }],
        text: 'Participant Flow Variables List'
      }
    },
    VariablesList: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/variables-list',
      description: 'The VariablesList Profile is used to provide a list of EvidenceVariable Resources.',
      htmlDescription: <span>The <b>VariablesList</b> Profile is used to provide a list of EvidenceVariable Resources.</span>,
      codeValue: {
        coding: [{
          system: 'https://fevir.net/resources/CodeSystem/179423',
          code: 'VariablesList',
          display: 'VariablesList'
        }],
        text: 'Variables List'
      }
    }
  },
  PlanDefinition: {
    SoaPlanDefinition: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/m11-soa-plandefinition',
      description: 'The SoaPlanDefinition Profile is used for temporary testing for coordination with M11 use.',
      htmlDescription: <span>The <b>SoaPlanDefinition</b> Profile is used for temporary testing for coordination with M11 use.</span>
    },
    RecommendationPlan: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-plan',
      description: 'The RecommendationPlan Profile is used for the implementable representation of a recommendation (such as that from a clinical practice guideline).',
      htmlDescription: <span>The <b>RecommendationPlan</b> Profile is used for the implementable representation of a recommendation (such as that from a clinical practice guideline).</span>,
      typeValue: {
        coding: [
          {
            system: "http://terminology.hl7.org/CodeSystem/plan-definition-type",
            code: "eca-rule",
            display: "ECA Rule"
          }
        ]
      }
    }
  },
  ResearchStudy: {
    M11ResearchStudy: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/m11-research-study',
      description: 'The M11ResearchStudy Profile is used to add extensions for use with an M11 Report.',
      htmlDescription: <span>The <b>M11ResearchStudy</b> Profile is used to add extensions for use with an M11 Report.</span>
    },
    StudyDesign: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/study-design',
      description: 'The StudyDesign Profile is used to add extensions for additional expressions of study design features with the study protocol.',
      htmlDescription: <span>The <b>StudyDesign</b> Profile is used to add extensions for additional expressions of study design features with the study protocol.</span>
    },
    StudyRegistryRecord: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/study-registry-record',
      description: 'The StudyRegistryRecord Profile is used for a scientific study record in a research study registry, such as ClinicalTrials.gov or the European Union Clinical Trial Information System (EU CTIS).',
      htmlDescription: <span>The <b>StudyRegistryRecord</b> Profile is used for a scientific study record in a research study registry, such as ClinicalTrials.gov or the European Union Clinical Trial Information System (EU CTIS).</span>
    },
    SystematicReview: {
      url: 'http://hl7.org/fhir/uv/ebm/StructureDefinition/systematic-review',
      description: 'The SystematicReview Profile is used for a scientific study based on a protocol that includes search and selection of eligible studies, study quality assessment, data extraction, and synthesis.',
      htmlDescription: <span>The <b>SystematicReview</b> Profile is used for a scientific study based on a protocol that includes search and selection of eligible studies, study quality assessment, data extraction, and synthesis.</span>
    }
  }
}

export default ProfilesByResourceType;